// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://src` | (string & {});
};

/**
 * Action
 *
 * Action.
 */
export type Action = {
    /**
     * Name
     */
    name: string;
    /**
     * Title
     */
    title: string | null;
    /**
     * Method
     */
    method: string;
    /**
     * Href
     */
    href: string;
    /**
     * Operation
     */
    operation: string | null;
};

/**
 * ApiKey
 *
 * Schema for an API key.
 */
export type ApiKey = {
    /**
     * Identity
     *
     * ID of the API key
     */
    identity: string;
    /**
     * Name
     *
     * Name of the API key
     */
    name: string;
    /**
     * Created At
     *
     * Creation timestamp
     */
    created_at: Date;
    /**
     * Expires At
     *
     * Expiration timestamp
     */
    expires_at?: Date | null;
    /**
     * Last Used At
     *
     * Last used timestamp
     */
    last_used_at?: Date | null;
};

/**
 * ApiKeyCreated
 *
 * Schema for a newly created API key.
 */
export type ApiKeyCreated = {
    /**
     * Identity
     *
     * ID of the API key
     */
    identity: string;
    /**
     * Name
     *
     * Name of the API key
     */
    name: string;
    /**
     * Created At
     *
     * Creation timestamp
     */
    created_at: Date;
    /**
     * Expires At
     *
     * Expiration timestamp
     */
    expires_at?: Date | null;
    /**
     * Last Used At
     *
     * Last used timestamp
     */
    last_used_at?: Date | null;
    /**
     * Key
     *
     * The API key (only shown once)
     */
    key: string;
};

/**
 * ApiKeysList
 *
 * Schema for a list of API keys.
 */
export type ApiKeysList = {
    /**
     * Api Keys
     *
     * List of API keys
     */
    api_keys: Array<ApiKey>;
};

/**
 * Artefact
 *
 * Response body for Artefact.
 */
export type Artefact = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Mimetype
     */
    mimetype: string;
    /**
     * Links
     */
    links?: {
        [key: string]: Hateoas;
    };
    /**
     * Preview
     */
    preview: string | null;
};

/**
 * ArtefactGroupWithArtefacts
 *
 * Response body for Artefact group with artefacts.
 */
export type ArtefactGroupWithArtefacts = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Artefacts
     */
    artefacts: Array<Artefact | ArtefactGroupWithArtefacts>;
};

/**
 * Body_create_api_integration_stek_integration_mgt_integration_settings__integration_type__post
 */
export type BodyCreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePost = {
    /**
     * Api Key
     */
    api_key: string;
    /**
     * Host
     */
    host?: string | null;
};

/**
 * Body_create_api_key__user_api_key_post
 */
export type BodyCreateApiKeyUserApiKeyPost = {
    /**
     * Name
     */
    name: string;
    /**
     * Expires At
     */
    expires_at?: Date | null;
};

/**
 * Body_generate_authorization_code_integrations_oauth2_server_authorize_post
 */
export type BodyGenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePost = {
    /**
     * Organization Id
     */
    organization_id: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Client Id
     */
    client_id: string;
    /**
     * Redirect Uri
     */
    redirect_uri: string;
    /**
     * Scope
     */
    scope: string;
    /**
     * Code Challenge
     */
    code_challenge: string;
    /**
     * Code Challenge Method
     */
    code_challenge_method?: string;
    /**
     * State
     */
    state?: string | null;
    /**
     * Authorization Token
     */
    authorization_token: string;
    /**
     * Organization Header
     */
    organization_header?: string | null;
    /**
     * Stek Header
     */
    stek_header?: string | null;
};

/**
 * Body_start_biz_artefact_management_add_artefact_group_start_post
 */
export type BodyStartBizArtefactManagementAddArtefactGroupStartPost = {
    /**
     * Owner Id
     */
    owner_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Commit Message
     *
     * Added {artefact.name}
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_add_artefact_start_post
 */
export type BodyStartBizArtefactManagementAddArtefactStartPost = {
    /**
     * Owner Id
     */
    owner_id: string;
    /**
     * File
     */
    file_: Blob | File;
    /**
     * Commit Message
     *
     * Added {artefact.name}
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_get_artefact_start_post
 */
export type BodyStartBizArtefactManagementGetArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Revision
     */
    revision?: string | null;
};

/**
 * Body_start_biz_artefact_management_get_artefacts_tree_start_post
 */
export type BodyStartBizArtefactManagementGetArtefactsTreeStartPost = {
    /**
     * Artefact Group Id
     */
    artefact_group_id: string;
};

/**
 * Body_start_biz_artefact_management_get_history_start_post
 */
export type BodyStartBizArtefactManagementGetHistoryStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Offset
     */
    offset?: number;
};

/**
 * Body_start_biz_artefact_management_remove_artefact_group_start_post
 */
export type BodyStartBizArtefactManagementRemoveArtefactGroupStartPost = {
    /**
     * Artefact Group Id
     */
    artefact_group_id: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_remove_artefact_start_post
 */
export type BodyStartBizArtefactManagementRemoveArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_rename_artefact_group_start_post
 */
export type BodyStartBizArtefactManagementRenameArtefactGroupStartPost = {
    /**
     * Artefact Group Id
     */
    artefact_group_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_rename_artefact_start_post
 */
export type BodyStartBizArtefactManagementRenameArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_restore_historical_artefact_start_post
 */
export type BodyStartBizArtefactManagementRestoreHistoricalArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Revision
     */
    revision: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_update_artefact_content_start_post
 */
export type BodyStartBizArtefactManagementUpdateArtefactContentStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * File
     */
    file_: Blob | File;
    /**
     * Commit Message
     *
     * Added {artefact.name}
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_update_artefact_start_post
 */
export type BodyStartBizArtefactManagementUpdateArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Content
     */
    content?: Blob | File | null;
    /**
     * Commit Message
     *
     * Added {artefact.name}
     */
    commit_message?: string;
};

/**
 * Body_start_biz_entities__entity_type___entity_id___attribute__restore_post
 */
export type BodyStartBizEntitiesEntityTypeEntityIdAttributeRestorePost = {
    /**
     * Revision
     */
    revision: string;
};

/**
 * Body_start_dashboard_dashboard_mgt_update_dashboard_start_post
 */
export type BodyStartDashboardDashboardMgtUpdateDashboardStartPost = {
    /**
     * Dashboard Id
     */
    dashboard_id: string;
    /**
     * Widgets
     */
    widgets: Array<Widget>;
};

/**
 * Body_start_domain_business_entity_mgt_create_business_entity_start_post
 */
export type BodyStartDomainBusinessEntityMgtCreateBusinessEntityStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Confidentiality Level
     */
    confidentiality_level?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Definition
     */
    definition?: Blob | File | null;
    /**
     * Relationships
     *
     * JSON string containing an array of relationship objects. Each relationship should have 'type', 'other_id', and 'direction' fields. Example: '[{"type": "depends on", "other_id": "entity2", "direction": "outgoing"}]'
     */
    relationships?: string | null;
};

/**
 * Body_start_domain_business_entity_mgt_delete_business_entity_start_post
 */
export type BodyStartDomainBusinessEntityMgtDeleteBusinessEntityStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_entities_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessEntitiesStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_entity_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessEntityStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_update_business_entity_start_post
 */
export type BodyStartDomainBusinessEntityMgtUpdateBusinessEntityStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Confidentiality Level
     */
    confidentiality_level?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Definition
     */
    definition?: Blob | File | null;
    /**
     * Relationships
     *
     * JSON string containing an array of relationship objects. Each relationship should have 'type', 'other_id', and 'direction' fields. Example: '[{"type": "depends on", "other_id": "entity2", "direction": "outgoing"}]'
     */
    relationships?: string | null;
};

/**
 * Body_start_domain_domain_mgt_create_domain_start_post
 */
export type BodyStartDomainDomainMgtCreateDomainStartPost = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_domain_mgt_delete_domain_start_post
 */
export type BodyStartDomainDomainMgtDeleteDomainStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_domain_mgt_get_domain_start_post
 */
export type BodyStartDomainDomainMgtGetDomainStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Revision
     */
    revision?: string | null;
};

/**
 * Body_start_domain_domain_mgt_update_domain_orders_start_post
 */
export type BodyStartDomainDomainMgtUpdateDomainOrdersStartPost = {
    /**
     * Domain Ids
     */
    domain_ids: Array<string>;
};

/**
 * Body_start_domain_domain_mgt_update_domain_start_post
 */
export type BodyStartDomainDomainMgtUpdateDomainStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Order Index
     */
    order_index?: number | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_domain_term_mgt_create_domain_term_start_post
 */
export type BodyStartDomainDomainTermMgtCreateDomainTermStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_domain_term_mgt_delete_domain_term_start_post
 */
export type BodyStartDomainDomainTermMgtDeleteDomainTermStartPost = {
    /**
     * Domain Term Id
     */
    domain_term_id: string;
};

/**
 * Body_start_domain_domain_term_mgt_get_domain_term_start_post
 */
export type BodyStartDomainDomainTermMgtGetDomainTermStartPost = {
    /**
     * Domain Term Id
     */
    domain_term_id: string;
};

/**
 * Body_start_domain_domain_term_mgt_get_domain_terms_start_post
 */
export type BodyStartDomainDomainTermMgtGetDomainTermsStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_domain_term_mgt_update_domain_term_start_post
 */
export type BodyStartDomainDomainTermMgtUpdateDomainTermStartPost = {
    /**
     * Domain Term Id
     */
    domain_term_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_role_mgt_create_role_start_post
 */
export type BodyStartDomainRoleMgtCreateRoleStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_role_mgt_delete_role_start_post
 */
export type BodyStartDomainRoleMgtDeleteRoleStartPost = {
    /**
     * Role Id
     */
    role_id: string;
};

/**
 * Body_start_domain_role_mgt_get_role_start_post
 */
export type BodyStartDomainRoleMgtGetRoleStartPost = {
    /**
     * Role Id
     */
    role_id: string;
    /**
     * Revision
     */
    revision?: string | null;
};

/**
 * Body_start_domain_role_mgt_get_roles_start_post
 */
export type BodyStartDomainRoleMgtGetRolesStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_role_mgt_update_role_start_post
 */
export type BodyStartDomainRoleMgtUpdateRoleStartPost = {
    /**
     * Role Id
     */
    role_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_process_lane_mgt_get_lane_by_bpmn_id_start_post
 */
export type BodyStartProcessLaneMgtGetLaneByBpmnIdStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
};

/**
 * Body_start_process_lane_mgt_get_lane_by_role_id_start_post
 */
export type BodyStartProcessLaneMgtGetLaneByRoleIdStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Role Id
     */
    role_id: string;
};

/**
 * Body_start_process_lane_mgt_get_lane_start_post
 */
export type BodyStartProcessLaneMgtGetLaneStartPost = {
    /**
     * Lane Id
     */
    lane_id: string;
};

/**
 * Body_start_process_lane_mgt_get_lanes_by_process_start_post
 */
export type BodyStartProcessLaneMgtGetLanesByProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
};

/**
 * Body_start_process_process_element_mgt_archive_process_element_start_post
 */
export type BodyStartProcessProcessElementMgtArchiveProcessElementStartPost = {
    /**
     * Task Id
     */
    task_id: string;
};

/**
 * Body_start_process_process_element_mgt_delete_event_start_post
 */
export type BodyStartProcessProcessElementMgtDeleteEventStartPost = {
    /**
     * Event Id
     */
    event_id: string;
};

/**
 * Body_start_process_process_element_mgt_delete_flow_start_post
 */
export type BodyStartProcessProcessElementMgtDeleteFlowStartPost = {
    /**
     * Flow Id
     */
    flow_id: string;
};

/**
 * Body_start_process_process_element_mgt_delete_gateway_start_post
 */
export type BodyStartProcessProcessElementMgtDeleteGatewayStartPost = {
    /**
     * Gateway Id
     */
    gateway_id: string;
};

/**
 * Body_start_process_process_element_mgt_delete_task_start_post
 */
export type BodyStartProcessProcessElementMgtDeleteTaskStartPost = {
    /**
     * Task Id
     */
    task_id: string;
};

/**
 * Body_start_process_process_element_mgt_generate_user_interface_start_post
 */
export type BodyStartProcessProcessElementMgtGenerateUserInterfaceStartPost = {
    /**
     * Task Id
     */
    task_id: string;
};

/**
 * Body_start_process_process_element_mgt_get_event_start_post
 */
export type BodyStartProcessProcessElementMgtGetEventStartPost = {
    /**
     * Event Id
     */
    event_id: string;
    /**
     * Revision
     */
    revision?: string | null;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_flow_start_post
 */
export type BodyStartProcessProcessElementMgtGetFlowStartPost = {
    /**
     * Flow Id
     */
    flow_id: string;
    /**
     * Revision
     */
    revision?: string | null;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_gateway_start_post
 */
export type BodyStartProcessProcessElementMgtGetGatewayStartPost = {
    /**
     * Gateway Id
     */
    gateway_id: string;
    /**
     * Revision
     */
    revision?: string | null;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_process_element_by_bpmn_id_start_post
 */
export type BodyStartProcessProcessElementMgtGetProcessElementByBpmnIdStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_process_elements_by_entity_start_post
 */
export type BodyStartProcessProcessElementMgtGetProcessElementsByEntityStartPost = {
    /**
     * Entity Id
     */
    entity_id: string;
};

/**
 * Body_start_process_process_element_mgt_get_process_elements_by_process_start_post
 */
export type BodyStartProcessProcessElementMgtGetProcessElementsByProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_task_start_post
 */
export type BodyStartProcessProcessElementMgtGetTaskStartPost = {
    /**
     * Task Id
     */
    task_id: string;
    /**
     * Revision
     */
    revision?: string | null;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_unarchive_process_element_start_post
 */
export type BodyStartProcessProcessElementMgtUnarchiveProcessElementStartPost = {
    /**
     * Process Element Id
     */
    process_element_id: string;
};

/**
 * Body_start_process_process_element_mgt_update_event_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateEventStartPost = {
    /**
     * Event Id
     */
    event_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_process_process_element_mgt_update_flow_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateFlowStartPost = {
    /**
     * Flow Id
     */
    flow_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_process_process_element_mgt_update_gateway_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateGatewayStartPost = {
    /**
     * Gateway Id
     */
    gateway_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_process_process_element_mgt_update_process_element_entity_refs_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPost = {
    /**
     * Process Element Id
     */
    process_element_id: string;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
};

/**
 * Body_start_process_process_element_mgt_update_task_evidence_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateTaskEvidenceStartPost = {
    /**
     * Task Id
     */
    task_id: string;
    /**
     * Generates Evidence
     */
    generates_evidence: boolean;
    /**
     * Evidence Instructions
     */
    evidence_instructions?: Blob | File | null;
};

/**
 * Body_start_process_process_element_mgt_update_task_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateTaskStartPost = {
    /**
     * Task Id
     */
    task_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Ui Code
     */
    ui_code?: Blob | File | null;
};

/**
 * Body_start_process_process_mgt_create_process_start_post
 */
export type BodyStartProcessProcessMgtCreateProcessStartPost = {
    /**
     * Product Id
     */
    product_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Process Definition
     */
    process_definition?: Blob | File | null;
    /**
     * Process Definition Preview
     */
    process_definition_preview?: string | null;
};

/**
 * Body_start_process_process_mgt_delete_process_start_post
 */
export type BodyStartProcessProcessMgtDeleteProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
};

/**
 * Body_start_process_process_mgt_deploy_process_start_post
 */
export type BodyStartProcessProcessMgtDeployProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Definition Path
     */
    definition_path: string;
};

/**
 * Body_start_process_process_mgt_generate_definition_xml_start_post
 */
export type BodyStartProcessProcessMgtGenerateDefinitionXmlStartPost = {
    /**
     * Prompt
     */
    prompt: string;
    /**
     * Process Id
     */
    process_id: string;
};

/**
 * Body_start_process_process_mgt_get_process_start_post
 */
export type BodyStartProcessProcessMgtGetProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Revision
     */
    revision?: string | null;
};

/**
 * Body_start_process_process_mgt_get_processes_by_product_start_post
 */
export type BodyStartProcessProcessMgtGetProcessesByProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_process_process_mgt_move_process_start_post
 */
export type BodyStartProcessProcessMgtMoveProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Target Product Id
     */
    target_product_id: string;
};

/**
 * Body_start_process_process_mgt_update_process_orders_start_post
 */
export type BodyStartProcessProcessMgtUpdateProcessOrdersStartPost = {
    /**
     * Process Ids
     */
    process_ids: Array<string>;
};

/**
 * Body_start_process_process_mgt_update_process_start_post
 */
export type BodyStartProcessProcessMgtUpdateProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Order Index
     */
    order_index?: number | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Process Definition
     */
    process_definition?: Blob | File | null;
    /**
     * Process Definition Preview
     */
    process_definition_preview?: string | null;
};

/**
 * Body_start_product_product_mgt_create_product_start_post
 */
export type BodyStartProductProductMgtCreateProductStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_product_product_mgt_delete_product_start_post
 */
export type BodyStartProductProductMgtDeleteProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_product_product_mgt_get_product_start_post
 */
export type BodyStartProductProductMgtGetProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
    /**
     * Revision
     */
    revision?: string | null;
};

/**
 * Body_start_product_product_mgt_get_products_by_domain_start_post
 */
export type BodyStartProductProductMgtGetProductsByDomainStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_product_product_mgt_move_product_start_post
 */
export type BodyStartProductProductMgtMoveProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
    /**
     * Target Domain Id
     */
    target_domain_id: string;
};

/**
 * Body_start_product_product_mgt_update_product_orders_start_post
 */
export type BodyStartProductProductMgtUpdateProductOrdersStartPost = {
    /**
     * Product Ids
     */
    product_ids: Array<string>;
};

/**
 * Body_start_product_product_mgt_update_product_start_post
 */
export type BodyStartProductProductMgtUpdateProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Order Index
     */
    order_index?: number | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_stek_live_mgt_get_compliance_evidence_start_post
 */
export type BodyStartStekLiveMgtGetComplianceEvidenceStartPost = {
    /**
     * Process Instance Id
     */
    process_instance_id: string;
    /**
     * Hours
     */
    hours?: number;
};

/**
 * Body_start_stek_live_mgt_get_metrics_start_post
 */
export type BodyStartStekLiveMgtGetMetricsStartPost = {
    /**
     * Stek Id
     */
    stek_id?: string | null;
    /**
     * Domain Id
     */
    domain_id?: string | null;
    /**
     * Product Id
     */
    product_id?: string | null;
    /**
     * Process Id
     */
    process_id?: string | null;
    /**
     * Hours
     */
    hours?: number;
    /**
     * Stek Release
     */
    stek_release?: string | null;
};

/**
 * Body_start_stek_live_mgt_get_process_instances_start_post
 */
export type BodyStartStekLiveMgtGetProcessInstancesStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Hours
     */
    hours?: number;
    /**
     * Stek Release
     */
    stek_release?: string | null;
};

/**
 * Body_start_stek_live_mgt_ingest_event_start_post
 */
export type BodyStartStekLiveMgtIngestEventStartPost = {
    /**
     * Stek Release
     */
    stek_release: string;
    /**
     * Event Type
     */
    event_type?: string;
    payload?: IngestEventPayload;
    /**
     * Timestamp
     */
    timestamp?: Date | null;
    /**
     * Process Instance Id
     */
    process_instance_id?: string | null;
    /**
     * Domain Id
     */
    domain_id?: string | null;
    /**
     * Product Id
     */
    product_id?: string | null;
    /**
     * Process Id
     */
    process_id?: string | null;
    /**
     * Process Element Id
     */
    process_element_id?: string | null;
    /**
     * Business Key
     */
    business_key?: string | null;
};

/**
 * Body_start_stek_stek_mgt_create_stek_start_post
 */
export type BodyStartStekStekMgtCreateStekStartPost = {
    /**
     * Name
     */
    name: string;
    /**
     * Fqdn
     */
    fqdn?: string;
    /**
     * Logo
     */
    logo?: Blob | File | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_stek_stek_mgt_generate_stek_details_start_post
 */
export type BodyStartStekStekMgtGenerateStekDetailsStartPost = {
    /**
     * Sources
     */
    sources: Array<string>;
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_stek_stek_mgt_import_stek_start_post
 */
export type BodyStartStekStekMgtImportStekStartPost = {
    /**
     * File
     */
    file: Blob | File;
    /**
     * Name
     */
    name?: string | null;
};

/**
 * Body_start_stek_stek_mgt_manage_stek_start_post
 */
export type BodyStartStekStekMgtManageStekStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Compliance Enabled
     */
    compliance_enabled?: boolean | null;
    /**
     * Live Mode Enabled
     */
    live_mode_enabled?: boolean | null;
};

/**
 * Body_start_stek_stek_mgt_update_stek_start_post
 */
export type BodyStartStekStekMgtUpdateStekStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Logo
     */
    logo?: Blob | File | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Mission
     */
    mission?: Blob | File | null;
    /**
     * Vision
     */
    vision?: Blob | File | null;
    /**
     * Core Values
     */
    core_values?: Blob | File | null;
    /**
     * Specializations
     */
    specializations?: Blob | File | null;
    /**
     * Target Markets
     */
    target_markets?: Blob | File | null;
    /**
     * Fqdn
     */
    fqdn?: string | null;
};

/**
 * Body_start_stek_stek_release_mgt_get_release_start_post
 */
export type BodyStartStekStekReleaseMgtGetReleaseStartPost = {
    /**
     * Release Name
     */
    release_name: string;
};

/**
 * Body_start_workspace_worktree_mgt_get_worktree_start_post
 */
export type BodyStartWorkspaceWorktreeMgtGetWorktreeStartPost = {
    /**
     * Workspace Id
     */
    workspace_id: string;
    /**
     * Revision
     */
    revision?: string | null;
};

/**
 * Body_test_integration_connection_stek_integration_mgt_integration_test__integration_type__post
 */
export type BodyTestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePost = {
    /**
     * Api Key
     */
    api_key: string;
    /**
     * Host
     */
    host?: string | null;
};

/**
 * Body_token_endpoint_integrations_oauth2_server_token_post
 */
export type BodyTokenEndpointIntegrationsOauth2ServerTokenPost = {
    /**
     * Grant Type
     */
    grant_type: string;
    /**
     * Code
     */
    code?: string | null;
    /**
     * Redirect Uri
     */
    redirect_uri?: string | null;
    /**
     * Code Verifier
     */
    code_verifier?: string | null;
    /**
     * Client Id
     */
    client_id?: string | null;
    /**
     * Refresh Token
     */
    refresh_token?: string | null;
};

/**
 * BusinessEntity
 *
 * Business entity response.
 */
export type BusinessEntity = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    confidentiality_level?: ConfidentialityLevel | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    definition?: Artefact | null;
    /**
     * Attribute Count
     */
    attribute_count?: number;
    /**
     * Relationships
     */
    relationships: Array<BusinessEntityRelationship>;
};

/**
 * BusinessEntityRelationship
 *
 * Business entity relationship for API requests/responses.
 */
export type BusinessEntityRelationship = {
    /**
     * Type
     */
    type: string;
    /**
     * Other Id
     */
    other_id: string;
    direction: RelationshipDirection;
};

/**
 * ClientRegistrationRequest
 *
 * Client registration request.
 */
export type ClientRegistrationRequest = {
    /**
     * Redirect Uris
     */
    redirect_uris: Array<string>;
    /**
     * Client Name
     */
    client_name?: string | null;
    /**
     * Scope
     */
    scope?: string | null;
    /**
     * Token Endpoint Auth Method
     */
    token_endpoint_auth_method?: string;
    /**
     * Grant Types
     */
    grant_types?: Array<string>;
    /**
     * Response Types
     */
    response_types?: Array<string>;
};

/**
 * ClusterRole
 *
 * The role of the user across the organization.
 */
export enum ClusterRole {
    USER = 'user',
    STEK_MANAGER = 'stek-manager',
    USER_MANAGER = 'user-manager',
    ORGANIZATION_MANAGER = 'organization-manager',
    VIEWER = 'viewer'
}

/**
 * ComplianceEvidenceItem
 *
 * A single compliance evidence item in the event payload.
 *
 * Represents proof of task/process execution for audit purposes.
 */
export type ComplianceEvidenceItem = {
    /**
     * Id
     *
     * Unique identifier for this evidence item
     */
    id: string;
    /**
     * Type of evidence: 'uri' (link to document) or 'description' (text proof)
     */
    type: ComplianceEvidenceType;
    /**
     * Value
     *
     * The evidence content: URL for 'uri' type, text description for 'description' type
     */
    value: string;
    /**
     * Description
     *
     * Human-readable description of what this evidence proves
     */
    description: string;
    /**
     * Timestamp
     *
     * When this evidence was created (ISO 8601 format)
     */
    timestamp: Date;
    /**
     * Created By
     *
     * User ID or email of who created this evidence
     */
    created_by?: string | null;
};

/**
 * ComplianceEvidenceType
 *
 * Types of compliance evidence.
 *
 * URI: Link to external evidence (documents, screenshots, etc.)
 * DESCRIPTION: Text description of evidence
 */
export enum ComplianceEvidenceType {
    URI = 'uri',
    DESCRIPTION = 'description'
}

/**
 * ComplianceEvidenceView
 *
 * View model for compliance evidence with event context.
 */
export type ComplianceEvidenceView = {
    /**
     * Id
     */
    id: string;
    /**
     * Type
     */
    type: string;
    /**
     * Value
     */
    value: string;
    /**
     * Description
     */
    description: string;
    /**
     * Timestamp
     */
    timestamp: Date;
    /**
     * Created By
     */
    created_by: string | null;
    /**
     * Event Id
     */
    event_id: string;
    /**
     * Event Type
     */
    event_type: string;
    /**
     * Event Timestamp
     */
    event_timestamp: Date;
    /**
     * Process Instance Id
     */
    process_instance_id: string;
    /**
     * Business Key
     */
    business_key: string | null;
    /**
     * Process Element Id
     */
    process_element_id: string | null;
    /**
     * Process Element Name
     */
    process_element_name: string | null;
};

/**
 * ComplianceProof
 *
 * Container for compliance evidence in event payload.
 *
 * Events can include one or more pieces of evidence to prove compliance
 * with controls, requirements, or audit needs.
 */
export type ComplianceProof = {
    /**
     * Evidence
     *
     * List of evidence items attached to this event
     */
    evidence: Array<ComplianceEvidenceItem>;
    /**
     * Metadata
     *
     * Optional metadata about the compliance proof
     */
    metadata?: {
        [key: string]: string;
    };
};

/**
 * ConfidentialityLevel
 *
 * Data confidentiality classification for a business entity.
 */
export enum ConfidentialityLevel {
    PUBLIC = 'public',
    INTERNAL = 'internal',
    CONFIDENTIAL = 'confidential',
    RESTRICTED = 'restricted'
}

/**
 * CreateEntity
 *
 * Function to create a connection between two elements.
 */
export type CreateEntity = {
    /**
     * Name
     */
    name: string;
    /**
     * Type
     */
    type: string;
    /**
     * Description
     */
    description: string;
};

/**
 * CreateReleaseRequest
 *
 * Request to create a new stek release.
 */
export type CreateReleaseRequest = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * CreateUser
 *
 * Create a new user.
 */
export type CreateUser = {
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name?: string | null;
};

/**
 * CreateUserWithInvitation
 *
 * Create a new user via invitation.
 */
export type CreateUserWithInvitation = {
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name: string;
    /**
     * Token
     */
    token: string;
};

/**
 * Dashboard
 *
 * Dashboard within MyStekz.
 */
export type Dashboard = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Widgets
     */
    widgets?: Array<Widget>;
};

/**
 * DiffStatResponse
 *
 * Diff statistics for a single file.
 */
export type DiffStatResponse = {
    /**
     * Path
     */
    path: string;
    /**
     * Additions
     */
    additions: number;
    /**
     * Deletions
     */
    deletions: number;
    /**
     * Old Path
     */
    old_path?: string | null;
};

/**
 * Domain
 *
 * Request body for Domain.
 */
export type Domain = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
};

/**
 * DomainCommitResponse
 *
 * Snapshot of a domain at a specific release.
 */
export type DomainCommitResponse = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Domain Name
     */
    domain_name: string;
    /**
     * Commit Id
     */
    commit_id: string;
};

/**
 * DomainDiffResponse
 *
 * Diff for a single domain between two releases.
 */
export type DomainDiffResponse = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Domain Name
     */
    domain_name: string;
    /**
     * From Ref
     */
    from_ref: string;
    /**
     * To Ref
     */
    to_ref: string;
    /**
     * Files Changed
     */
    files_changed: number;
    /**
     * Additions
     */
    additions: number;
    /**
     * Deletions
     */
    deletions: number;
    /**
     * Changed Files
     */
    changed_files: Array<DiffStatResponse>;
};

/**
 * DomainInTree
 *
 * Domain representation inside worktree, does not describe Domain.
 */
export type DomainInTree = {
    /**
     * Identity
     */
    identity: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Order Index
     */
    order_index: number;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * Products
     */
    products: Array<ProductInTree>;
};

/**
 * DomainRole
 *
 * The domain roles in relation to the user.
 */
export type DomainRole = {
    /**
     * Role Name
     */
    role_name: string;
    /**
     * Domain Name
     */
    domain_name: string;
    /**
     * Authorized
     */
    authorized: boolean;
};

/**
 * DomainTerm
 *
 * API schema for a DomainTerm.
 */
export type DomainTerm = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
};

/**
 * EntityInfo
 *
 * Entity information.
 */
export type EntityInfo = {
    /**
     * Identity
     */
    identity: string;
    entity_type: EntityType;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * Thumbnail
     */
    thumbnail?: string | null;
    parent?: EntityInfo | null;
};

/**
 * EntityRef
 *
 * Reference from a ProcessElement to a BusinessEntity with a free-form label.
 */
export type EntityRef = {
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Label
     */
    label: string;
};

/**
 * EntityTaskRef
 *
 * A process task that references a business entity, returned when querying entity usage.
 */
export type EntityTaskRef = {
    /**
     * Task Id
     */
    task_id: string;
    /**
     * Task Name
     */
    task_name: string;
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Process Name
     */
    process_name: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Label
     */
    label: string;
};

/**
 * EntityType
 */
export enum EntityType {
    ORGANIZATION = 'organization',
    STEK = 'stek',
    DOMAIN = 'domain',
    PRODUCT = 'product',
    ROLE = 'role',
    PROCESS = 'process',
    TASK = 'task',
    GATEWAY = 'gateway',
    EVENT = 'event',
    FLOW = 'flow',
    ARTEFACT = 'artefact',
    ARTEFACT_GROUP = 'artefact_group',
    BUSINESS_ENTITY = 'business_entity',
    DOMAIN_TERM = 'domain_term',
    DOCUMENT = 'document'
}

/**
 * ErrorType
 *
 * An exhaustive list of domain errors.
 *
 * The list MUST be extended for application specific error messages. The convention is:
 * <DOMAIN>_<ERROR_DESCRIPTION>
 *
 * Please be kind to you coding mates and give it a descriptive name, no need for shorthands.
 */
export enum ErrorType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12
}

/**
 * FirebaseUser
 *
 * Firebase user record with authentication details.
 */
export type FirebaseUser = {
    /**
     * Uid
     *
     * Firebase user UID
     */
    uid: string;
    /**
     * Email
     *
     * User email address
     */
    email?: string | null;
    /**
     * Email Verified
     *
     * Whether email is verified
     */
    email_verified?: boolean;
    /**
     * Display Name
     *
     * User display name
     */
    display_name?: string | null;
    /**
     * Photo Url
     *
     * User profile photo URL
     */
    photo_url?: string | null;
    /**
     * Phone Number
     *
     * User phone number
     */
    phone_number?: string | null;
    /**
     * Disabled
     *
     * Whether account is disabled
     */
    disabled?: boolean;
    /**
     * Provider Data
     *
     * List of sign-in providers
     */
    provider_data?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Tokens Valid After Time
     *
     * Tokens issued before this time are invalid
     */
    tokens_valid_after_time?: Date | null;
    /**
     * User Metadata Creation Time
     *
     * Account creation time
     */
    user_metadata_creation_time?: Date | null;
    /**
     * User Metadata Last Sign In Time
     *
     * Last sign-in time
     */
    user_metadata_last_sign_in_time?: Date | null;
    /**
     * User Metadata Last Refresh Time
     *
     * Last token refresh time
     */
    user_metadata_last_refresh_time?: Date | null;
    /**
     * Custom Claims
     *
     * Custom user claims
     */
    custom_claims?: {
        [key: string]: unknown;
    } | null;
    /**
     * Tenant Id
     *
     * Tenant ID for multi-tenancy
     */
    tenant_id?: string | null;
    /**
     * Mfa Info
     *
     * Multi-factor authentication enrollments
     */
    mfa_info?: Array<FirebaseUserMfaInfo>;
};

/**
 * FirebaseUserMfaInfo
 *
 * MFA information for a Firebase user.
 */
export type FirebaseUserMfaInfo = {
    /**
     * Uid
     *
     * Unique identifier for the MFA enrollment
     */
    uid: string;
    /**
     * Phone Number
     *
     * Phone number for MFA
     */
    phone_number?: string | null;
    /**
     * Display Name
     *
     * Display name for MFA enrollment
     */
    display_name?: string | null;
    /**
     * Enrollment Time
     *
     * When MFA was enrolled
     */
    enrollment_time?: Date | null;
    /**
     * Factor Id
     *
     * Type of MFA factor (e.g., 'phone')
     */
    factor_id: string;
};

/**
 * GetReleaseDiffRequest
 *
 * Request to get diff between releases.
 */
export type GetReleaseDiffRequest = {
    /**
     * To Release
     */
    to_release: string;
    /**
     * From Release
     */
    from_release?: string | null;
};

/**
 * GetTaskEvaluationsRequest
 *
 * Request to get task evaluations for a specific task name.
 */
export type GetTaskEvaluationsRequest = {
    /**
     * Task Name
     *
     * Name of the task to get evaluations for
     */
    task_name: string;
};

/**
 * GetTaskProvidersRequest
 *
 * Request to get task providers for a specific task type.
 */
export type GetTaskProvidersRequest = {
    /**
     * Type of task to get providers for
     */
    task_type: TaskType;
};

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
    /**
     * Detail
     */
    detail?: Array<ValidationError>;
};

/**
 * Hateoas
 *
 * Response body for Hoteos.
 */
export type Hateoas = {
    /**
     * Href
     */
    href: string;
    /**
     * Type
     */
    type: string;
};

/**
 * HintPreferences
 *
 * User hint/UI preferences.
 */
export type HintPreferences = {
    /**
     * Hints Enabled
     */
    hints_enabled?: boolean | null;
    /**
     * Seen Hints
     */
    seen_hints?: Array<string> | null;
};

/**
 * HttpDetail
 */
export type HttpDetail = {
    /**
     * Message
     */
    message: string;
    /**
     * Type
     */
    type: unknown;
};

/**
 * HttpExceptionModel
 */
export type HttpExceptionModel = {
    /**
     * Detail
     */
    detail: Array<HttpDetail>;
};

/**
 * IngestEventPayload
 *
 * Event payload structure for ingesting live mode events.
 *
 * The payload can contain arbitrary data, but compliance_proof follows
 * a specific structure when present.
 */
export type IngestEventPayload = {
    /**
     * Optional compliance evidence attached to this event
     */
    compliance_proof?: ComplianceProof | null;
    [key: string]: unknown;
};

/**
 * Integration
 *
 * Integration on a Stek level.
 */
export type Integration = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * User Id
     */
    user_id?: string | null;
    integration_type: IntegrationType;
    /**
     * Integration Method
     */
    integration_method: 'oauth2' | 'api_key' | null;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Updated At
     */
    updated_at: Date;
    /**
     * Last Sync At
     */
    last_sync_at?: Date | null;
    /**
     * Is Active
     */
    is_active: boolean;
    settings?: IntegrationSettings | null;
};

/**
 * IntegrationSettings
 *
 * Base model for integration settings.
 */
export type IntegrationSettings = {
    /**
     * Api Key
     */
    api_key?: string;
    /**
     * Host
     */
    host?: string | null;
};

/**
 * IntegrationStatus
 */
export enum IntegrationStatus {
    CONNECTED = 'connected',
    MISSING_INTEGRATION = 'missing_integration',
    MISSING_CREDENTIALS = 'missing_credentials',
    ERROR = 'error'
}

/**
 * IntegrationType
 *
 * Types of integrations that can be configured for an stek.
 */
export enum IntegrationType {
    CLICKUP = 'clickup',
    GITLAB = 'gitlab',
    MCP_OAUTH2 = 'mcp_oauth2'
}

/**
 * InvitationValidation
 *
 * Response for invitation token validation.
 */
export type InvitationValidation = {
    /**
     * Email
     */
    email: string;
    /**
     * Organization Name
     */
    organization_name: string;
};

/**
 * Lane
 *
 * Request body for Lane.
 */
export type Lane = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Role Id
     */
    role_id?: string | null;
};

/**
 * LinkPreview
 *
 * Link preview data model for API responses.
 */
export type LinkPreview = {
    /**
     * Title
     */
    title?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Image
     */
    image?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    integration_status?: IntegrationStatus | null;
};

/**
 * LiveMetrics
 *
 * Aggregated metrics for live mode monitoring.
 */
export type LiveMetrics = {
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Entity Type
     */
    entity_type: string;
    /**
     * Time Range Start
     */
    time_range_start: Date;
    /**
     * Time Range End
     */
    time_range_end: Date;
    /**
     * Total Events
     */
    total_events: number;
    /**
     * Events By Type
     */
    events_by_type: {
        [key: string]: number;
    };
    /**
     * Error Count
     */
    error_count: number;
    /**
     * Error Rate
     */
    error_rate: number;
    /**
     * Process Instance Count
     */
    process_instance_count?: number | null;
    /**
     * Time Series Data
     */
    time_series_data: Array<{
        [key: string]: unknown;
    }>;
};

/**
 * MeUser
 *
 * User object which exposes all authorizations roles in all organizatios for the user.
 */
export type MeUser = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Email
     */
    email: string;
    /**
     * Roles
     */
    roles: {
        [key: string]: Array<ClusterRole>;
    };
    /**
     * Permissions
     */
    permissions: {
        [key: string]: UserPermissions;
    };
    /**
     * Profile Picture
     */
    profile_picture?: string | null;
    preferences?: HintPreferences | null;
};

/**
 * ModelConfig
 *
 * Model configuration for task evaluation.
 */
export type ModelConfig = {
    /**
     * Model provider (OpenAI or Anthropic)
     */
    provider?: ModelProvider;
    /**
     * Model
     *
     * Model name (e.g., gpt-4.1, claude-3-sonnet)
     */
    model?: string;
    /**
     * Temperature
     *
     * Model temperature (0.0 to 1.0)
     */
    temperature?: number;
    /**
     * Max Tokens
     *
     * Maximum tokens to generate
     */
    max_tokens?: number;
};

/**
 * ModelProvider
 *
 * Available model providers.
 */
export enum ModelProvider {
    OPENAI = 'openai',
    ANTHROPIC = 'anthropic'
}

/**
 * OAuthMetadata
 *
 * OAuth2 server metadata for discovery.
 */
export type OAuthMetadata = {
    /**
     * Issuer
     */
    issuer: string;
    /**
     * Authorization Endpoint
     */
    authorization_endpoint: string;
    /**
     * Token Endpoint
     */
    token_endpoint: string;
    /**
     * Registration Endpoint
     */
    registration_endpoint?: string | null;
    /**
     * Revocation Endpoint
     */
    revocation_endpoint?: string | null;
    /**
     * Scopes Supported
     */
    scopes_supported?: Array<string>;
    /**
     * Response Types Supported
     */
    response_types_supported?: Array<string>;
    /**
     * Grant Types Supported
     */
    grant_types_supported?: Array<string>;
    /**
     * Code Challenge Methods Supported
     */
    code_challenge_methods_supported?: Array<string>;
    /**
     * Token Endpoint Auth Methods Supported
     */
    token_endpoint_auth_methods_supported?: Array<string>;
};

/**
 * OAuthProtectedResourceMetadata
 *
 * OAuth2 protected resource metadata for discovery (RFC 9728).
 */
export type OAuthProtectedResourceMetadata = {
    /**
     * Resource
     */
    resource: string;
    /**
     * Authorization Servers
     */
    authorization_servers: Array<string>;
    /**
     * Scopes Supported
     */
    scopes_supported?: Array<string>;
    /**
     * Resource Name
     */
    resource_name?: string | null;
    /**
     * Resource Documentation
     */
    resource_documentation?: string | null;
};

/**
 * Organization
 *
 * Organization within MyStekz.
 */
export type Organization = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: string | null;
};

/**
 * OrganizationActivityReportResponse
 *
 * Activity report response.
 */
export type OrganizationActivityReportResponse = {
    /**
     * Time Period Days
     */
    time_period_days: number;
    /**
     * Report Generated At
     */
    report_generated_at: Date;
    /**
     * Organizations
     */
    organizations: Array<OrganizationActivityResponse>;
};

/**
 * OrganizationActivityResponse
 *
 * Organization activity response.
 */
export type OrganizationActivityResponse = {
    /**
     * Organization Id
     */
    organization_id: string;
    /**
     * Organization Name
     */
    organization_name: string;
    /**
     * Total Users
     */
    total_users: number;
    /**
     * Last Activity At
     */
    last_activity_at: Date | null;
    /**
     * Active Users In Period
     */
    active_users_in_period: number;
    /**
     * Total Auth Events In Period
     */
    total_auth_events_in_period: number;
    /**
     * User Activities
     */
    user_activities: Array<UserActivityResponse>;
};

/**
 * OrganizationUser
 *
 * User model scoped to a specific organization.
 */
export type OrganizationUser = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Email
     */
    email: string;
    /**
     * Roles
     */
    roles: Array<ClusterRole>;
    /**
     * Name
     */
    name: string;
    /**
     * Profile Picture
     */
    profile_picture?: string | null;
    /**
     * Status
     */
    status?: string | null;
    /**
     * Invitation Sent At
     */
    invitation_sent_at?: Date | null;
    /**
     * Invitation Expires At
     */
    invitation_expires_at?: Date | null;
    /**
     * Actions
     */
    _actions?: Array<Action>;
};

/**
 * PolicyAcceptance
 *
 * Schema for a policy acceptance record
 *
 * Returned when retrieving policy acceptance history
 */
export type PolicyAcceptance = {
    /**
     * Id
     *
     * ID of the acceptance record
     */
    id: number;
    /**
     * User Id
     *
     * ID of the user who accepted
     */
    user_id: string;
    /**
     * Policy Type
     *
     * Type of policy accepted
     */
    policy_type: string;
    /**
     * Version
     *
     * Version of the policy accepted
     */
    version: string;
    /**
     * Accepted At
     *
     * When the policy was accepted
     */
    accepted_at: Date;
    /**
     * User Agent
     *
     * User agent when accepted
     */
    user_agent?: string | null;
};

/**
 * PolicyAcceptanceRequest
 *
 * Schema for recording user acceptance of a policy (privacy/terms)
 *
 * Used when user explicitly accepts a policy with version information
 */
export type PolicyAcceptanceRequest = {
    /**
     * Policy Type
     *
     * Type of policy: 'privacy_policy' or 'terms_conditions'
     */
    policy_type: string;
    /**
     * Version
     *
     * Policy version (optional, defaults to current version)
     */
    version?: string | null;
    /**
     * User Agent
     *
     * User agent string (optional)
     */
    user_agent?: string | null;
};

/**
 * PolicyAcceptanceStatus
 *
 * Schema for checking if user has accepted current policies.
 * Used to determine if user needs to accept new policy versions.
 */
export type PolicyAcceptanceStatus = {
    /**
     * Needs Privacy Policy Acceptance
     *
     * Needs to accept a (new) privacy policy.
     */
    needs_privacy_policy_acceptance: boolean;
    /**
     * Privacy Policy Accepted
     *
     * Has accepted current privacy policy
     */
    privacy_policy_accepted: boolean;
    /**
     * Privacy Policy Version
     *
     * Version of privacy policy accepted
     */
    privacy_policy_version?: string | null;
    /**
     * Privacy Policy Accepted At
     *
     * When privacy policy was accepted
     */
    privacy_policy_accepted_at?: Date | null;
    /**
     * Needs Terms Conditions Acceptance
     *
     * Needs to accept a (new) terms of use.
     */
    needs_terms_conditions_acceptance: boolean;
    /**
     * Terms Conditions Accepted
     *
     * Has accepted current terms of use
     */
    terms_conditions_accepted: boolean;
    /**
     * Terms Conditions Version
     *
     * Version of terms of use accepted
     */
    terms_conditions_version?: string | null;
    /**
     * Terms Conditions Accepted At
     *
     * When terms of use were accepted
     */
    terms_conditions_accepted_at?: Date | null;
};

/**
 * PrepareResponse
 */
export type PrepareResponse = {
    /**
     * Auth Url
     */
    auth_url: string;
};

/**
 * Process
 *
 * Request body for Product.
 */
export type Process = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    process_definition?: Artefact | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * Is Generating
     */
    is_generating?: boolean;
};

/**
 * ProcessElement
 *
 * Request body for Task.
 */
export type ProcessElement = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
};

/**
 * ProcessElementType
 */
export enum ProcessElementType {
    TASK = 'task',
    GATEWAY = 'gateway',
    EVENT = 'event',
    FLOW = 'flow'
}

/**
 * ProcessEvent
 */
export type ProcessEvent = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type?: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
};

/**
 * ProcessFlow
 */
export type ProcessFlow = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type?: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
};

/**
 * ProcessGateway
 */
export type ProcessGateway = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type?: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
};

/**
 * ProcessInTree
 *
 * Process representation inside worktree, does not describe Process.
 */
export type ProcessInTree = {
    /**
     * Identity
     */
    identity: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Order Index
     */
    order_index: number;
    /**
     * Short Description
     */
    short_description?: string | null;
};

/**
 * ProcessInstanceMetrics
 *
 * Runtime metrics for a single process instance.
 */
export type ProcessInstanceMetrics = {
    /**
     * Process Instance Id
     */
    process_instance_id: string;
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Business Key
     */
    business_key?: string | null;
    /**
     * Stek Release
     */
    stek_release: string;
    /**
     * Started At
     */
    started_at: Date;
    /**
     * Last Event At
     */
    last_event_at: Date;
    /**
     * Duration Seconds
     */
    duration_seconds?: number | null;
    /**
     * Total Events
     */
    total_events: number;
    /**
     * Error Count
     */
    error_count: number;
    /**
     * Compliance Proof Count
     */
    compliance_proof_count?: number;
    /**
     * Status
     */
    status: 'running' | 'completed' | 'failed';
    /**
     * Events By Type
     */
    events_by_type: {
        [key: string]: number;
    };
};

/**
 * ProcessTask
 */
export type ProcessTask = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type?: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
    ui_code?: Artefact | null;
    /**
     * Generates Evidence
     */
    generates_evidence?: boolean;
    evidence_instructions?: Artefact | null;
};

/**
 * Product
 *
 * Request body for Product.
 */
export type Product = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
};

/**
 * ProductInTree
 *
 * Product representation inside worktree, does not describe Product.
 */
export type ProductInTree = {
    /**
     * Identity
     */
    identity: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Order Index
     */
    order_index: number;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * Processes
     */
    processes: Array<ProcessInTree>;
};

/**
 * RelationshipDirection
 *
 * Direction of a relationship from the perspective of the current entity.
 */
export enum RelationshipDirection {
    OUTGOING = 'outgoing',
    INCOMING = 'incoming'
}

/**
 * ReleaseDiffResponse
 *
 * Combined diff across all domains between two releases.
 */
export type ReleaseDiffResponse = {
    /**
     * From Release
     */
    from_release: string | null;
    /**
     * To Release
     */
    to_release: string;
    /**
     * Domain Diffs
     */
    domain_diffs: Array<DomainDiffResponse>;
    /**
     * Total Files Changed
     */
    total_files_changed: number;
    /**
     * Total Additions
     */
    total_additions: number;
    /**
     * Total Deletions
     */
    total_deletions: number;
};

/**
 * RevocationRequest
 *
 * Token revocation request.
 */
export type RevocationRequest = {
    /**
     * Token
     */
    token: string;
    /**
     * Token Type Hint
     */
    token_type_hint?: string | null;
    /**
     * Client Id
     */
    client_id?: string | null;
};

/**
 * Role
 *
 * Request body for Role.
 */
export type Role = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Responsibilities
     */
    responsibilities?: Array<RoleResponsibility>;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
};

/**
 * RoleResponsibility
 *
 * Process Task is a RoleResponsibility.
 */
export type RoleResponsibility = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Process Name
     */
    process_name: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Short Description
     */
    short_description?: string | null;
};

/**
 * SearchResponse
 */
export type SearchResponse = {
    /**
     * Results
     */
    results: Array<SearchResultItem>;
};

/**
 * SearchResultItem
 */
export type SearchResultItem = {
    /**
     * Id
     */
    id: string;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Breadcrumbs
     */
    breadcrumbs?: Array<string> | null;
};

/**
 * Stek
 *
 * Request body for Stek.
 */
export type Stek = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Fqdn
     */
    fqdn: string;
    logo?: Artefact | null;
    description?: Artefact | null;
    mission?: Artefact | null;
    vision?: Artefact | null;
    core_values?: Artefact | null;
    specializations?: Artefact | null;
    target_markets?: Artefact | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Compliance Enabled
     */
    compliance_enabled?: boolean;
    /**
     * Live Mode Enabled
     */
    live_mode_enabled?: boolean;
};

/**
 * StekEvent
 *
 * An event from a running Stek for live mode monitoring.
 */
export type StekEvent = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Event Type
     */
    event_type: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Stek Release
     */
    stek_release: string;
    /**
     * Process Instance Id
     */
    process_instance_id: string;
    /**
     * Domain Id
     */
    domain_id?: string | null;
    /**
     * Product Id
     */
    product_id?: string | null;
    /**
     * Process Id
     */
    process_id?: string | null;
    /**
     * Process Element Id
     */
    process_element_id?: string | null;
    /**
     * Business Key
     */
    business_key?: string | null;
    /**
     * Payload
     */
    payload: {
        [key: string]: unknown;
    };
    /**
     * Timestamp
     *
     * The moment the event occurred in the running Stek (Business Time)
     */
    timestamp: Date;
    /**
     * Created At
     *
     * The moment the event was ingested by our backend (System Time)
     */
    created_at: Date;
};

/**
 * StekGeneratedDetails
 *
 * Subsections that define the structure of a stek.
 */
export type StekGeneratedDetails = {
    /**
     * Description
     */
    description?: string | null;
    /**
     * Mission
     */
    mission?: string | null;
    /**
     * Vision
     */
    vision?: string | null;
    /**
     * Core Values
     */
    core_values?: string | null;
    /**
     * Specializations
     */
    specializations?: string | null;
    /**
     * Target Markets
     */
    target_markets?: string | null;
};

/**
 * StekReleaseResponse
 *
 * Response for a stek release.
 */
export type StekReleaseResponse = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Created By
     */
    created_by: string;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Domain Commits
     */
    domain_commits: Array<DomainCommitResponse>;
};

/**
 * SupportedProvidersResponse
 *
 * Response containing the supported providers for a task type.
 */
export type SupportedProvidersResponse = {
    /**
     * The task type
     */
    task_type: TaskType;
    /**
     * Supported Providers
     *
     * List of supported providers for this task type
     */
    supported_providers: Array<ModelProvider>;
};

/**
 * TaskEvaluationListResponse
 *
 * Response for listing task evaluations.
 */
export type TaskEvaluationListResponse = {
    /**
     * Results
     *
     * List of task evaluation results
     */
    results: Array<TaskEvaluationResult>;
};

/**
 * TaskEvaluationRequest
 *
 * Request for task evaluation.
 */
export type TaskEvaluationRequest = {
    /**
     * Type of task to evaluate
     */
    task_type: TaskType;
    /**
     * Task Config
     *
     * Configuration parameters for the task
     */
    task_config: {
        [key: string]: unknown;
    };
    /**
     * Agent Config
     *
     * Agent configuration (name, system_message, description)
     */
    agent_config: {
        [key: string]: unknown;
    };
    /**
     * Model configuration
     */
    llm_config: ModelConfig;
};

/**
 * TaskEvaluationResult
 *
 * Result of a task evaluation.
 */
export type TaskEvaluationResult = {
    /**
     * Task Name
     *
     * Name of the task
     */
    task_name: string;
    /**
     * Timestamp
     *
     * Timestamp of the task execution
     */
    timestamp: string;
    /**
     * Execution Time Seconds
     *
     * Execution time in seconds
     */
    execution_time_seconds: number;
    /**
     * Agent Name
     *
     * Name of the agent used
     */
    agent_name: string;
    /**
     * Agent System Message
     *
     * System message used for instructing the agent
     */
    agent_system_message?: string | null;
    /**
     * Agent Description
     *
     * Description of the agent
     */
    agent_description?: string | null;
    /**
     * Prompt
     *
     * Prompt used for the task
     */
    prompt: string;
    /**
     * Context Prompt
     *
     * Context prompt used for the task
     */
    context_prompt?: string | null;
    /**
     * Function
     *
     * Function used to execute the task
     */
    function: string;
    /**
     * Output
     *
     * Output of the task
     */
    output: string;
    /**
     * Llm Config
     *
     * LLM configuration used
     */
    llm_config: {
        [key: string]: unknown;
    };
    /**
     * Variation Id
     *
     * Variation identifier if part of a batch run
     */
    variation_id?: string | null;
};

/**
 * TaskType
 *
 * Available task types for evaluation.
 */
export enum TaskType {
    GENERATE_DESCRIPTION = 'generate_description',
    GENERATE_DEFINITION_XML = 'generate_definition_xml',
    GENERATE_USER_INTERFACE = 'generate_user_interface'
}

/**
 * TokenRequest
 *
 * Request body for token exchange endpoint.
 */
export type TokenRequest = {
    /**
     * Code
     */
    code: string;
    /**
     * State
     */
    state: string;
    /**
     * Redirect Uri
     */
    redirect_uri: string;
    /**
     * Integration Type
     */
    integration_type: string;
};

/**
 * UpdatePreferences
 *
 * Patch payload for updating user preferences.
 */
export type UpdatePreferences = {
    /**
     * Hints Enabled
     */
    hints_enabled?: boolean | null;
    /**
     * Seen Hints
     */
    seen_hints?: Array<string> | null;
};

/**
 * UpdateUser
 *
 * Update a user.
 */
export type UpdateUser = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Profile Picture
     */
    profile_picture?: string | null;
};

/**
 * UpdateUserAuthorization
 *
 * Request body for updating the full list of roles for a user in an organization.
 */
export type UpdateUserAuthorization = {
    /**
     * Cluster Roles
     */
    cluster_roles: Array<ClusterRole>;
};

/**
 * UserActivityResponse
 *
 * User activity response.
 */
export type UserActivityResponse = {
    /**
     * User Id
     */
    user_id: string;
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name: string;
    /**
     * Last Auth At
     */
    last_auth_at: Date | null;
    /**
     * Last Api Key Usage At
     */
    last_api_key_usage_at: Date | null;
    /**
     * Last Activity At
     */
    last_activity_at: Date | null;
    /**
     * Auth Count In Period
     */
    auth_count_in_period: number;
};

/**
 * UserPermissions
 *
 * The permissions of the user.
 */
export type UserPermissions = {
    /**
     * Can Create Stek
     */
    can_create_stek: boolean;
    /**
     * Can Delete Stek
     */
    can_delete_stek: boolean;
    /**
     * Can Manage Stek Settings
     */
    can_manage_stek_settings: boolean;
    /**
     * Can Manage Users
     */
    can_manage_users: boolean;
    /**
     * Can Manage Steks
     */
    can_manage_steks: boolean;
    /**
     * Can View Activity Metrics
     */
    can_view_activity_metrics: boolean;
};

/**
 * ValidateInvitationRequest
 *
 * Request body for validating an invitation token.
 */
export type ValidateInvitationRequest = {
    /**
     * Token
     */
    token: string;
};

/**
 * ValidationError
 */
export type ValidationError = {
    /**
     * Location
     */
    loc: Array<string | number>;
    /**
     * Message
     */
    msg: string;
    /**
     * Error Type
     */
    type: string;
};

/**
 * Widget
 *
 * Widget within a Dashboard.
 */
export type Widget = {
    /**
     * X
     */
    x: number;
    /**
     * Y
     */
    y: number;
    /**
     * W
     */
    w: number;
    /**
     * H
     */
    h: number;
    /**
     * Content
     */
    content: string;
};

/**
 * Worktree
 *
 * A worktree represents the hierarchy of a system, described in terms of
 * domains, products and processes. It can be used to render a tree view of
 * the system.
 *
 * Note, the schema does not expose the branch that is used across all
 * entities (stek and its domains), unlike the domain entity.
 */
export type Worktree = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Domains
     */
    domains: Array<DomainInTree>;
};

/**
 * Contributor
 *
 * An author or committer of a HistoryEntry.
 */
export type DomainBizEntitiesContributor = {
    /**
     * Name
     */
    name: string;
    /**
     * Email
     */
    email: string;
    /**
     * Date
     */
    date: string;
};

/**
 * HistoryEntry
 *
 * A value object which represents a point in time of the artefact.
 */
export type DomainBizEntitiesHistoryEntry = {
    /**
     * Id
     */
    id: string;
    /**
     * Subject
     */
    subject: string;
    /**
     * Body
     */
    body: string;
    author: DomainBizEntitiesContributor;
    committer: DomainBizEntitiesContributor;
};

/**
 * UserActivity
 *
 * Request body for user activity.
 */
export type UserActivity = {
    /**
     * Session Slug
     */
    session_slug?: string | null;
    /**
     * User Name
     */
    user_name: string;
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Photo Url
     */
    photo_url?: string | null;
    /**
     * Is Editing
     */
    is_editing: boolean;
    /**
     * Timestamp
     */
    timestamp: number;
};

/**
 * ActivityUpdate
 *
 * Request body for activity update.
 */
export type ActivityUpdate = {
    /**
     * Entity Id
     */
    entity_id?: string | null;
    /**
     * Is Editing
     */
    is_editing: boolean;
};

export type GetOauthMetadataWellKnownOauthAuthorizationServerGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/.well-known/oauth-authorization-server';
};

export type GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses = {
    /**
     * Successful Response
     */
    200: OAuthMetadata;
};

export type GetOauthMetadataWellKnownOauthAuthorizationServerGetResponse = GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses[keyof GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses];

export type GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/.well-known/oauth-protected-resource';
};

export type GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses = {
    /**
     * Successful Response
     */
    200: OAuthProtectedResourceMetadata;
};

export type GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponse = GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses[keyof GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses];

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Since Days
         *
         * Lookback period in days
         */
        since_days?: number;
        /**
         * Include User Details
         *
         * Include per-user breakdown
         */
        include_user_details?: boolean;
    };
    url: '/organization/activity_metrics/get_organization_activity/start';
};

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetError = StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors[keyof StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors];

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses = {
    /**
     * Successful Response
     */
    200: OrganizationActivityReportResponse;
};

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponse = StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses[keyof StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses];

export type StartOrganizationOrganizationMgtGetOrganizationsStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/organization/organization_mgt/get_organizations/start';
};

export type StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses = {
    /**
     * Response Start Organization Organization Mgt Get Organizations Start Post
     *
     * Successful Response
     */
    200: Array<Organization>;
};

export type StartOrganizationOrganizationMgtGetOrganizationsStartPostResponse = StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses[keyof StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses];

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Name
         */
        name: string;
    };
    url: '/organization/organization_mgt/get_organization_by_name/start';
};

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostError = StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors[keyof StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors];

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses = {
    /**
     * Successful Response
     */
    200: Organization;
};

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponse = StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses[keyof StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses];

export type StartBizArtefactManagementAddArtefactGroupStartPostData = {
    body: BodyStartBizArtefactManagementAddArtefactGroupStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/add_artefact_group/start';
};

export type StartBizArtefactManagementAddArtefactGroupStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementAddArtefactGroupStartPostError = StartBizArtefactManagementAddArtefactGroupStartPostErrors[keyof StartBizArtefactManagementAddArtefactGroupStartPostErrors];

export type StartBizArtefactManagementAddArtefactGroupStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementRemoveArtefactGroupStartPostData = {
    body: BodyStartBizArtefactManagementRemoveArtefactGroupStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/remove_artefact_group/start';
};

export type StartBizArtefactManagementRemoveArtefactGroupStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRemoveArtefactGroupStartPostError = StartBizArtefactManagementRemoveArtefactGroupStartPostErrors[keyof StartBizArtefactManagementRemoveArtefactGroupStartPostErrors];

export type StartBizArtefactManagementRemoveArtefactGroupStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementUpdateArtefactStartPostData = {
    body: BodyStartBizArtefactManagementUpdateArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/update_artefact/start';
};

export type StartBizArtefactManagementUpdateArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementUpdateArtefactStartPostError = StartBizArtefactManagementUpdateArtefactStartPostErrors[keyof StartBizArtefactManagementUpdateArtefactStartPostErrors];

export type StartBizArtefactManagementUpdateArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementAddArtefactStartPostData = {
    body: BodyStartBizArtefactManagementAddArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/add_artefact/start';
};

export type StartBizArtefactManagementAddArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementAddArtefactStartPostError = StartBizArtefactManagementAddArtefactStartPostErrors[keyof StartBizArtefactManagementAddArtefactStartPostErrors];

export type StartBizArtefactManagementAddArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: Artefact;
};

export type StartBizArtefactManagementAddArtefactStartPostResponse = StartBizArtefactManagementAddArtefactStartPostResponses[keyof StartBizArtefactManagementAddArtefactStartPostResponses];

export type StartBizArtefactManagementGetArtefactsTreeStartPostData = {
    body: BodyStartBizArtefactManagementGetArtefactsTreeStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/get_artefacts_tree/start';
};

export type StartBizArtefactManagementGetArtefactsTreeStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementGetArtefactsTreeStartPostError = StartBizArtefactManagementGetArtefactsTreeStartPostErrors[keyof StartBizArtefactManagementGetArtefactsTreeStartPostErrors];

export type StartBizArtefactManagementGetArtefactsTreeStartPostResponses = {
    /**
     * Response Start Biz Artefact Management Get Artefacts Tree Start Post
     *
     * Successful Response
     */
    200: Array<Artefact | ArtefactGroupWithArtefacts>;
};

export type StartBizArtefactManagementGetArtefactsTreeStartPostResponse = StartBizArtefactManagementGetArtefactsTreeStartPostResponses[keyof StartBizArtefactManagementGetArtefactsTreeStartPostResponses];

export type StartBizArtefactManagementRemoveArtefactStartPostData = {
    body: BodyStartBizArtefactManagementRemoveArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/remove_artefact/start';
};

export type StartBizArtefactManagementRemoveArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRemoveArtefactStartPostError = StartBizArtefactManagementRemoveArtefactStartPostErrors[keyof StartBizArtefactManagementRemoveArtefactStartPostErrors];

export type StartBizArtefactManagementRemoveArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementGetHistoryStartPostData = {
    body: BodyStartBizArtefactManagementGetHistoryStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/get_history/start';
};

export type StartBizArtefactManagementGetHistoryStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementGetHistoryStartPostError = StartBizArtefactManagementGetHistoryStartPostErrors[keyof StartBizArtefactManagementGetHistoryStartPostErrors];

export type StartBizArtefactManagementGetHistoryStartPostResponses = {
    /**
     * Response Start Biz Artefact Management Get History Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<DomainBizEntitiesHistoryEntry>;
    };
};

export type StartBizArtefactManagementGetHistoryStartPostResponse = StartBizArtefactManagementGetHistoryStartPostResponses[keyof StartBizArtefactManagementGetHistoryStartPostResponses];

export type StartBizArtefactManagementRenameArtefactGroupStartPostData = {
    body: BodyStartBizArtefactManagementRenameArtefactGroupStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/rename_artefact_group/start';
};

export type StartBizArtefactManagementRenameArtefactGroupStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRenameArtefactGroupStartPostError = StartBizArtefactManagementRenameArtefactGroupStartPostErrors[keyof StartBizArtefactManagementRenameArtefactGroupStartPostErrors];

export type StartBizArtefactManagementRenameArtefactGroupStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementGetArtefactStartPostData = {
    body: BodyStartBizArtefactManagementGetArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/get_artefact/start';
};

export type StartBizArtefactManagementGetArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementGetArtefactStartPostError = StartBizArtefactManagementGetArtefactStartPostErrors[keyof StartBizArtefactManagementGetArtefactStartPostErrors];

export type StartBizArtefactManagementGetArtefactStartPostResponses = {
    /**
     * File stream, can have any content-type.
     */
    200: unknown;
};

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostData = {
    body: BodyStartBizArtefactManagementRestoreHistoricalArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/restore_historical_artefact/start';
};

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostError = StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors[keyof StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors];

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementRenameArtefactStartPostData = {
    body: BodyStartBizArtefactManagementRenameArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/rename_artefact/start';
};

export type StartBizArtefactManagementRenameArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRenameArtefactStartPostError = StartBizArtefactManagementRenameArtefactStartPostErrors[keyof StartBizArtefactManagementRenameArtefactStartPostErrors];

export type StartBizArtefactManagementRenameArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementUpdateArtefactContentStartPostData = {
    body: BodyStartBizArtefactManagementUpdateArtefactContentStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/update_artefact_content/start';
};

export type StartBizArtefactManagementUpdateArtefactContentStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementUpdateArtefactContentStartPostError = StartBizArtefactManagementUpdateArtefactContentStartPostErrors[keyof StartBizArtefactManagementUpdateArtefactContentStartPostErrors];

export type StartBizArtefactManagementUpdateArtefactContentStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizEntitiesEntityTypeEntityIdInfoGetData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
    };
    query?: never;
    url: '/biz/entities/{entity_type}/{entity_id}/info';
};

export type StartBizEntitiesEntityTypeEntityIdInfoGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdInfoGetError = StartBizEntitiesEntityTypeEntityIdInfoGetErrors[keyof StartBizEntitiesEntityTypeEntityIdInfoGetErrors];

export type StartBizEntitiesEntityTypeEntityIdInfoGetResponses = {
    /**
     * Successful Response
     */
    200: EntityInfo;
};

export type StartBizEntitiesEntityTypeEntityIdInfoGetResponse = StartBizEntitiesEntityTypeEntityIdInfoGetResponses[keyof StartBizEntitiesEntityTypeEntityIdInfoGetResponses];

export type StartBizEntitiesEntityTypeEntityIdAttributeGetData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
        /**
         * Attribute
         */
        attribute: string;
    };
    query?: {
        /**
         * Revision
         */
        revision?: string | null;
    };
    url: '/biz/entities/{entity_type}/{entity_id}/{attribute}';
};

export type StartBizEntitiesEntityTypeEntityIdAttributeGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdAttributeGetError = StartBizEntitiesEntityTypeEntityIdAttributeGetErrors[keyof StartBizEntitiesEntityTypeEntityIdAttributeGetErrors];

export type StartBizEntitiesEntityTypeEntityIdAttributeGetResponses = {
    /**
     * File stream, can have any content-type.
     */
    200: unknown;
};

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
        /**
         * Attribute
         */
        attribute: string;
    };
    query?: {
        /**
         * Limit
         */
        limit?: number;
        /**
         * Offset
         */
        offset?: number;
    };
    url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/history';
};

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetError = StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors[keyof StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors];

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses = {
    /**
     * Response Start Biz Entities  Entity Type   Entity Id   Attribute  History Get
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<DomainBizEntitiesHistoryEntry>;
    };
};

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponse = StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses[keyof StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses];

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData = {
    body: BodyStartBizEntitiesEntityTypeEntityIdAttributeRestorePost;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
        /**
         * Attribute
         */
        attribute: string;
    };
    query?: never;
    url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/restore';
};

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostError = StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors[keyof StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors];

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
    };
    query?: never;
    url: '/biz/entities/{entity_type}/{entity_id}/generate_description';
};

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostError = StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors[keyof StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors];

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses = {
    /**
     *
     * Limited stream of SSE messages. Sends `event: open` and `event: close` when opening/closing the stream.
     * Sends a JSON object with chunks of the content.
     *
     */
    200: string;
};

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponse = StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses[keyof StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses];

export type StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
    };
    query?: never;
    url: '/biz/entities/{entity_type}/{entity_id}/generate_children';
};

export type StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostError = StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostErrors[keyof StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostErrors];

export type StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponses = {
    /**
     * Response Start Biz Entities  Entity Type   Entity Id  Generate Children Post
     *
     * Successful Response
     */
    200: Array<CreateEntity>;
};

export type StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponse = StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponses[keyof StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponses];

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostData = {
    body: BodyStartWorkspaceWorktreeMgtGetWorktreeStartPost;
    path?: never;
    query?: never;
    url: '/workspace/worktree_mgt/get_worktree/start';
};

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostError = StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors[keyof StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors];

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses = {
    /**
     * Successful Response
     */
    200: Worktree;
};

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostResponse = StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses[keyof StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses];

export type StartStekStekReleaseMgtCreateReleaseStartPostData = {
    body: CreateReleaseRequest;
    path?: never;
    query?: never;
    url: '/stek/stek_release_mgt/create_release/start';
};

export type StartStekStekReleaseMgtCreateReleaseStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekReleaseMgtCreateReleaseStartPostError = StartStekStekReleaseMgtCreateReleaseStartPostErrors[keyof StartStekStekReleaseMgtCreateReleaseStartPostErrors];

export type StartStekStekReleaseMgtCreateReleaseStartPostResponses = {
    /**
     * Successful Response
     */
    200: StekReleaseResponse;
};

export type StartStekStekReleaseMgtCreateReleaseStartPostResponse = StartStekStekReleaseMgtCreateReleaseStartPostResponses[keyof StartStekStekReleaseMgtCreateReleaseStartPostResponses];

export type StartStekStekReleaseMgtGetReleaseDiffStartPostData = {
    body: GetReleaseDiffRequest;
    path?: never;
    query?: never;
    url: '/stek/stek_release_mgt/get_release_diff/start';
};

export type StartStekStekReleaseMgtGetReleaseDiffStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekReleaseMgtGetReleaseDiffStartPostError = StartStekStekReleaseMgtGetReleaseDiffStartPostErrors[keyof StartStekStekReleaseMgtGetReleaseDiffStartPostErrors];

export type StartStekStekReleaseMgtGetReleaseDiffStartPostResponses = {
    /**
     * Successful Response
     */
    200: ReleaseDiffResponse;
};

export type StartStekStekReleaseMgtGetReleaseDiffStartPostResponse = StartStekStekReleaseMgtGetReleaseDiffStartPostResponses[keyof StartStekStekReleaseMgtGetReleaseDiffStartPostResponses];

export type StartStekStekReleaseMgtGetReleaseStartPostData = {
    body: BodyStartStekStekReleaseMgtGetReleaseStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_release_mgt/get_release/start';
};

export type StartStekStekReleaseMgtGetReleaseStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekReleaseMgtGetReleaseStartPostError = StartStekStekReleaseMgtGetReleaseStartPostErrors[keyof StartStekStekReleaseMgtGetReleaseStartPostErrors];

export type StartStekStekReleaseMgtGetReleaseStartPostResponses = {
    /**
     * Successful Response
     */
    200: StekReleaseResponse;
};

export type StartStekStekReleaseMgtGetReleaseStartPostResponse = StartStekStekReleaseMgtGetReleaseStartPostResponses[keyof StartStekStekReleaseMgtGetReleaseStartPostResponses];

export type StartStekStekReleaseMgtListReleasesStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_release_mgt/list_releases/start';
};

export type StartStekStekReleaseMgtListReleasesStartPostResponses = {
    /**
     * Response Start Stek Stek Release Mgt List Releases Start Post
     *
     * Successful Response
     */
    200: Array<StekReleaseResponse>;
};

export type StartStekStekReleaseMgtListReleasesStartPostResponse = StartStekStekReleaseMgtListReleasesStartPostResponses[keyof StartStekStekReleaseMgtListReleasesStartPostResponses];

export type StartStekStekMgtTreeStartPostData = {
    /**
     * Revision
     */
    body?: string | null;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/tree/start';
};

export type StartStekStekMgtTreeStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtTreeStartPostError = StartStekStekMgtTreeStartPostErrors[keyof StartStekStekMgtTreeStartPostErrors];

export type StartStekStekMgtTreeStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtGetSteksByOrganizationStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/get_steks_by_organization/start';
};

export type StartStekStekMgtGetSteksByOrganizationStartPostResponses = {
    /**
     * Response Start Stek Stek Mgt Get Steks By Organization Start Post
     *
     * Successful Response
     */
    200: Array<Stek>;
};

export type StartStekStekMgtGetSteksByOrganizationStartPostResponse = StartStekStekMgtGetSteksByOrganizationStartPostResponses[keyof StartStekStekMgtGetSteksByOrganizationStartPostResponses];

export type StartStekStekMgtManageStekStartPostData = {
    body: BodyStartStekStekMgtManageStekStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/manage_stek/start';
};

export type StartStekStekMgtManageStekStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtManageStekStartPostError = StartStekStekMgtManageStekStartPostErrors[keyof StartStekStekMgtManageStekStartPostErrors];

export type StartStekStekMgtManageStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtCreateStekStartPostData = {
    body: BodyStartStekStekMgtCreateStekStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/create_stek/start';
};

export type StartStekStekMgtCreateStekStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtCreateStekStartPostError = StartStekStekMgtCreateStekStartPostErrors[keyof StartStekStekMgtCreateStekStartPostErrors];

export type StartStekStekMgtCreateStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtExportStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/export_stek/start';
};

export type StartStekStekMgtExportStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtGenerateStekDetailsStartPostData = {
    body: BodyStartStekStekMgtGenerateStekDetailsStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/generate_stek_details/start';
};

export type StartStekStekMgtGenerateStekDetailsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtGenerateStekDetailsStartPostError = StartStekStekMgtGenerateStekDetailsStartPostErrors[keyof StartStekStekMgtGenerateStekDetailsStartPostErrors];

export type StartStekStekMgtGenerateStekDetailsStartPostResponses = {
    /**
     * Successful Response
     */
    200: StekGeneratedDetails;
};

export type StartStekStekMgtGenerateStekDetailsStartPostResponse = StartStekStekMgtGenerateStekDetailsStartPostResponses[keyof StartStekStekMgtGenerateStekDetailsStartPostResponses];

export type StartStekStekMgtImportStekStartPostData = {
    body: BodyStartStekStekMgtImportStekStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/import_stek/start';
};

export type StartStekStekMgtImportStekStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtImportStekStartPostError = StartStekStekMgtImportStekStartPostErrors[keyof StartStekStekMgtImportStekStartPostErrors];

export type StartStekStekMgtImportStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtUpdateStekStartPostData = {
    body: BodyStartStekStekMgtUpdateStekStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/update_stek/start';
};

export type StartStekStekMgtUpdateStekStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtUpdateStekStartPostError = StartStekStekMgtUpdateStekStartPostErrors[keyof StartStekStekMgtUpdateStekStartPostErrors];

export type StartStekStekMgtUpdateStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtGetStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/get_stek/start';
};

export type StartStekStekMgtGetStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: Stek;
};

export type StartStekStekMgtGetStekStartPostResponse = StartStekStekMgtGetStekStartPostResponses[keyof StartStekStekMgtGetStekStartPostResponses];

export type StartStekStekMgtDeleteStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/delete_stek/start';
};

export type StartStekStekMgtDeleteStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteData = {
    body?: never;
    path: {
        integration_type: IntegrationType;
    };
    query?: never;
    url: '/stek/integration_mgt/integration/settings/{integration_type}';
};

export type DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteError = DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors[keyof DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors];

export type DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetData = {
    body?: never;
    path: {
        integration_type: IntegrationType;
    };
    query?: never;
    url: '/stek/integration_mgt/integration/settings/{integration_type}';
};

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetError = GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors[keyof GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors];

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses = {
    /**
     * Successful Response
     */
    200: Integration;
};

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponse = GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses[keyof GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses];

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostData = {
    body: BodyCreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePost;
    path: {
        integration_type: IntegrationType;
    };
    query?: never;
    url: '/stek/integration_mgt/integration/settings/{integration_type}';
};

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostError = CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors[keyof CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors];

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses = {
    /**
     * Successful Response
     */
    200: Integration;
};

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponse = CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses[keyof CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses];

export type TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostData = {
    body: BodyTestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePost;
    path: {
        integration_type: IntegrationType;
    };
    query?: never;
    url: '/stek/integration_mgt/integration/test/{integration_type}';
};

export type TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostError = TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors[keyof TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors];

export type TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekLiveMgtGetReleasesStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_releases/start';
};

export type StartStekLiveMgtGetReleasesStartPostResponses = {
    /**
     * Response Start Stek Live Mgt Get Releases Start Post
     *
     * Successful Response
     */
    200: Array<string>;
};

export type StartStekLiveMgtGetReleasesStartPostResponse = StartStekLiveMgtGetReleasesStartPostResponses[keyof StartStekLiveMgtGetReleasesStartPostResponses];

export type StartStekLiveMgtIngestEventStartPostData = {
    body: BodyStartStekLiveMgtIngestEventStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/ingest_event/start';
};

export type StartStekLiveMgtIngestEventStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtIngestEventStartPostError = StartStekLiveMgtIngestEventStartPostErrors[keyof StartStekLiveMgtIngestEventStartPostErrors];

export type StartStekLiveMgtIngestEventStartPostResponses = {
    /**
     * Successful Response
     */
    200: StekEvent;
};

export type StartStekLiveMgtIngestEventStartPostResponse = StartStekLiveMgtIngestEventStartPostResponses[keyof StartStekLiveMgtIngestEventStartPostResponses];

export type StartStekLiveMgtGetComplianceEvidenceStartPostData = {
    body: BodyStartStekLiveMgtGetComplianceEvidenceStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_compliance_evidence/start';
};

export type StartStekLiveMgtGetComplianceEvidenceStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtGetComplianceEvidenceStartPostError = StartStekLiveMgtGetComplianceEvidenceStartPostErrors[keyof StartStekLiveMgtGetComplianceEvidenceStartPostErrors];

export type StartStekLiveMgtGetComplianceEvidenceStartPostResponses = {
    /**
     * Response Start Stek Live Mgt Get Compliance Evidence Start Post
     *
     * Successful Response
     */
    200: Array<ComplianceEvidenceView>;
};

export type StartStekLiveMgtGetComplianceEvidenceStartPostResponse = StartStekLiveMgtGetComplianceEvidenceStartPostResponses[keyof StartStekLiveMgtGetComplianceEvidenceStartPostResponses];

export type StartStekLiveMgtGetProcessInstancesStartPostData = {
    body: BodyStartStekLiveMgtGetProcessInstancesStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_process_instances/start';
};

export type StartStekLiveMgtGetProcessInstancesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtGetProcessInstancesStartPostError = StartStekLiveMgtGetProcessInstancesStartPostErrors[keyof StartStekLiveMgtGetProcessInstancesStartPostErrors];

export type StartStekLiveMgtGetProcessInstancesStartPostResponses = {
    /**
     * Response Start Stek Live Mgt Get Process Instances Start Post
     *
     * Successful Response
     */
    200: Array<ProcessInstanceMetrics>;
};

export type StartStekLiveMgtGetProcessInstancesStartPostResponse = StartStekLiveMgtGetProcessInstancesStartPostResponses[keyof StartStekLiveMgtGetProcessInstancesStartPostResponses];

export type StartStekLiveMgtGetMetricsStartPostData = {
    body?: BodyStartStekLiveMgtGetMetricsStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_metrics/start';
};

export type StartStekLiveMgtGetMetricsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtGetMetricsStartPostError = StartStekLiveMgtGetMetricsStartPostErrors[keyof StartStekLiveMgtGetMetricsStartPostErrors];

export type StartStekLiveMgtGetMetricsStartPostResponses = {
    /**
     * Successful Response
     */
    200: LiveMetrics;
};

export type StartStekLiveMgtGetMetricsStartPostResponse = StartStekLiveMgtGetMetricsStartPostResponses[keyof StartStekLiveMgtGetMetricsStartPostResponses];

export type StartProductProductMgtGetProductStartPostData = {
    body: BodyStartProductProductMgtGetProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/get_product/start';
};

export type StartProductProductMgtGetProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtGetProductStartPostError = StartProductProductMgtGetProductStartPostErrors[keyof StartProductProductMgtGetProductStartPostErrors];

export type StartProductProductMgtGetProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: Product;
};

export type StartProductProductMgtGetProductStartPostResponse = StartProductProductMgtGetProductStartPostResponses[keyof StartProductProductMgtGetProductStartPostResponses];

export type StartProductProductMgtMoveProductStartPostData = {
    body: BodyStartProductProductMgtMoveProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/move_product/start';
};

export type StartProductProductMgtMoveProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtMoveProductStartPostError = StartProductProductMgtMoveProductStartPostErrors[keyof StartProductProductMgtMoveProductStartPostErrors];

export type StartProductProductMgtMoveProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProductProductMgtUpdateProductStartPostData = {
    body: BodyStartProductProductMgtUpdateProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/update_product/start';
};

export type StartProductProductMgtUpdateProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtUpdateProductStartPostError = StartProductProductMgtUpdateProductStartPostErrors[keyof StartProductProductMgtUpdateProductStartPostErrors];

export type StartProductProductMgtUpdateProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProductProductMgtDeleteProductStartPostData = {
    body: BodyStartProductProductMgtDeleteProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/delete_product/start';
};

export type StartProductProductMgtDeleteProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtDeleteProductStartPostError = StartProductProductMgtDeleteProductStartPostErrors[keyof StartProductProductMgtDeleteProductStartPostErrors];

export type StartProductProductMgtDeleteProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProductProductMgtCreateProductStartPostData = {
    body: BodyStartProductProductMgtCreateProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/create_product/start';
};

export type StartProductProductMgtCreateProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtCreateProductStartPostError = StartProductProductMgtCreateProductStartPostErrors[keyof StartProductProductMgtCreateProductStartPostErrors];

export type StartProductProductMgtCreateProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: Product;
};

export type StartProductProductMgtCreateProductStartPostResponse = StartProductProductMgtCreateProductStartPostResponses[keyof StartProductProductMgtCreateProductStartPostResponses];

export type StartProductProductMgtUpdateProductOrdersStartPostData = {
    body: BodyStartProductProductMgtUpdateProductOrdersStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/update_product_orders/start';
};

export type StartProductProductMgtUpdateProductOrdersStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtUpdateProductOrdersStartPostError = StartProductProductMgtUpdateProductOrdersStartPostErrors[keyof StartProductProductMgtUpdateProductOrdersStartPostErrors];

export type StartProductProductMgtUpdateProductOrdersStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProductProductMgtGetProductsByDomainStartPostData = {
    body: BodyStartProductProductMgtGetProductsByDomainStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/get_products_by_domain/start';
};

export type StartProductProductMgtGetProductsByDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtGetProductsByDomainStartPostError = StartProductProductMgtGetProductsByDomainStartPostErrors[keyof StartProductProductMgtGetProductsByDomainStartPostErrors];

export type StartProductProductMgtGetProductsByDomainStartPostResponses = {
    /**
     * Response Start Product Product Mgt Get Products By Domain Start Post
     *
     * Successful Response
     */
    200: Array<Product>;
};

export type StartProductProductMgtGetProductsByDomainStartPostResponse = StartProductProductMgtGetProductsByDomainStartPostResponses[keyof StartProductProductMgtGetProductsByDomainStartPostResponses];

export type StartDashboardDashboardMgtGetDashboardsByStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dashboard/dashboard_mgt/get_dashboards_by_stek/start';
};

export type StartDashboardDashboardMgtGetDashboardsByStekStartPostResponses = {
    /**
     * Response Start Dashboard Dashboard Mgt Get Dashboards By Stek Start Post
     *
     * Successful Response
     */
    200: Array<Dashboard>;
};

export type StartDashboardDashboardMgtGetDashboardsByStekStartPostResponse = StartDashboardDashboardMgtGetDashboardsByStekStartPostResponses[keyof StartDashboardDashboardMgtGetDashboardsByStekStartPostResponses];

export type StartDashboardDashboardMgtUpdateDashboardStartPostData = {
    body: BodyStartDashboardDashboardMgtUpdateDashboardStartPost;
    path?: never;
    query?: never;
    url: '/dashboard/dashboard_mgt/update_dashboard/start';
};

export type StartDashboardDashboardMgtUpdateDashboardStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDashboardDashboardMgtUpdateDashboardStartPostError = StartDashboardDashboardMgtUpdateDashboardStartPostErrors[keyof StartDashboardDashboardMgtUpdateDashboardStartPostErrors];

export type StartDashboardDashboardMgtUpdateDashboardStartPostResponses = {
    /**
     * Successful Response
     */
    200: Dashboard;
};

export type StartDashboardDashboardMgtUpdateDashboardStartPostResponse = StartDashboardDashboardMgtUpdateDashboardStartPostResponses[keyof StartDashboardDashboardMgtUpdateDashboardStartPostResponses];

export type StartDomainDomainMgtDeleteDomainStartPostData = {
    body: BodyStartDomainDomainMgtDeleteDomainStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/delete_domain/start';
};

export type StartDomainDomainMgtDeleteDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtDeleteDomainStartPostError = StartDomainDomainMgtDeleteDomainStartPostErrors[keyof StartDomainDomainMgtDeleteDomainStartPostErrors];

export type StartDomainDomainMgtDeleteDomainStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainDomainMgtGetDomainsByStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/get_domains_by_stek/start';
};

export type StartDomainDomainMgtGetDomainsByStekStartPostResponses = {
    /**
     * Response Start Domain Domain Mgt Get Domains By Stek Start Post
     *
     * Successful Response
     */
    200: Array<Domain>;
};

export type StartDomainDomainMgtGetDomainsByStekStartPostResponse = StartDomainDomainMgtGetDomainsByStekStartPostResponses[keyof StartDomainDomainMgtGetDomainsByStekStartPostResponses];

export type StartDomainDomainMgtUpdateDomainStartPostData = {
    body: BodyStartDomainDomainMgtUpdateDomainStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/update_domain/start';
};

export type StartDomainDomainMgtUpdateDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtUpdateDomainStartPostError = StartDomainDomainMgtUpdateDomainStartPostErrors[keyof StartDomainDomainMgtUpdateDomainStartPostErrors];

export type StartDomainDomainMgtUpdateDomainStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainDomainMgtGetDomainStartPostData = {
    body: BodyStartDomainDomainMgtGetDomainStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/get_domain/start';
};

export type StartDomainDomainMgtGetDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtGetDomainStartPostError = StartDomainDomainMgtGetDomainStartPostErrors[keyof StartDomainDomainMgtGetDomainStartPostErrors];

export type StartDomainDomainMgtGetDomainStartPostResponses = {
    /**
     * Successful Response
     */
    200: Domain;
};

export type StartDomainDomainMgtGetDomainStartPostResponse = StartDomainDomainMgtGetDomainStartPostResponses[keyof StartDomainDomainMgtGetDomainStartPostResponses];

export type StartDomainDomainMgtUpdateDomainOrdersStartPostData = {
    body: BodyStartDomainDomainMgtUpdateDomainOrdersStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/update_domain_orders/start';
};

export type StartDomainDomainMgtUpdateDomainOrdersStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtUpdateDomainOrdersStartPostError = StartDomainDomainMgtUpdateDomainOrdersStartPostErrors[keyof StartDomainDomainMgtUpdateDomainOrdersStartPostErrors];

export type StartDomainDomainMgtUpdateDomainOrdersStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainDomainMgtCreateDomainStartPostData = {
    body: BodyStartDomainDomainMgtCreateDomainStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/create_domain/start';
};

export type StartDomainDomainMgtCreateDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtCreateDomainStartPostError = StartDomainDomainMgtCreateDomainStartPostErrors[keyof StartDomainDomainMgtCreateDomainStartPostErrors];

export type StartDomainDomainMgtCreateDomainStartPostResponses = {
    /**
     * Successful Response
     */
    200: Domain;
};

export type StartDomainDomainMgtCreateDomainStartPostResponse = StartDomainDomainMgtCreateDomainStartPostResponses[keyof StartDomainDomainMgtCreateDomainStartPostResponses];

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData = {
    body: BodyStartDomainBusinessEntityMgtUpdateBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/update_business_entity/start';
};

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostError = StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors[keyof StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors];

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_entity/start';
};

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostError = StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: BusinessEntity;
};

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponse = StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses];

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData = {
    body: BodyStartDomainBusinessEntityMgtCreateBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/create_business_entity/start';
};

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostError = StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors[keyof StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors];

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData = {
    body: BodyStartDomainBusinessEntityMgtDeleteBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/delete_business_entity/start';
};

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostError = StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors[keyof StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors];

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessEntitiesStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_entities/start';
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostError = StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt Get Business Entities Start Post
     *
     * Successful Response
     */
    200: Array<BusinessEntity>;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponse = StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses];

export type StartDomainRoleMgtGetRolesStartPostData = {
    body: BodyStartDomainRoleMgtGetRolesStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/get_roles/start';
};

export type StartDomainRoleMgtGetRolesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtGetRolesStartPostError = StartDomainRoleMgtGetRolesStartPostErrors[keyof StartDomainRoleMgtGetRolesStartPostErrors];

export type StartDomainRoleMgtGetRolesStartPostResponses = {
    /**
     * Response Start Domain Role Mgt Get Roles Start Post
     *
     * Successful Response
     */
    200: Array<Role>;
};

export type StartDomainRoleMgtGetRolesStartPostResponse = StartDomainRoleMgtGetRolesStartPostResponses[keyof StartDomainRoleMgtGetRolesStartPostResponses];

export type StartDomainRoleMgtCreateRoleStartPostData = {
    body: BodyStartDomainRoleMgtCreateRoleStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/create_role/start';
};

export type StartDomainRoleMgtCreateRoleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtCreateRoleStartPostError = StartDomainRoleMgtCreateRoleStartPostErrors[keyof StartDomainRoleMgtCreateRoleStartPostErrors];

export type StartDomainRoleMgtCreateRoleStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainRoleMgtUpdateRoleStartPostData = {
    body: BodyStartDomainRoleMgtUpdateRoleStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/update_role/start';
};

export type StartDomainRoleMgtUpdateRoleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtUpdateRoleStartPostError = StartDomainRoleMgtUpdateRoleStartPostErrors[keyof StartDomainRoleMgtUpdateRoleStartPostErrors];

export type StartDomainRoleMgtUpdateRoleStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainRoleMgtDeleteRoleStartPostData = {
    body: BodyStartDomainRoleMgtDeleteRoleStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/delete_role/start';
};

export type StartDomainRoleMgtDeleteRoleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtDeleteRoleStartPostError = StartDomainRoleMgtDeleteRoleStartPostErrors[keyof StartDomainRoleMgtDeleteRoleStartPostErrors];

export type StartDomainRoleMgtDeleteRoleStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainRoleMgtGetRoleStartPostData = {
    body: BodyStartDomainRoleMgtGetRoleStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/get_role/start';
};

export type StartDomainRoleMgtGetRoleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtGetRoleStartPostError = StartDomainRoleMgtGetRoleStartPostErrors[keyof StartDomainRoleMgtGetRoleStartPostErrors];

export type StartDomainRoleMgtGetRoleStartPostResponses = {
    /**
     * Successful Response
     */
    200: Role;
};

export type StartDomainRoleMgtGetRoleStartPostResponse = StartDomainRoleMgtGetRoleStartPostResponses[keyof StartDomainRoleMgtGetRoleStartPostResponses];

export type StartDomainDomainTermMgtCreateDomainTermStartPostData = {
    body: BodyStartDomainDomainTermMgtCreateDomainTermStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/create_domain_term/start';
};

export type StartDomainDomainTermMgtCreateDomainTermStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtCreateDomainTermStartPostError = StartDomainDomainTermMgtCreateDomainTermStartPostErrors[keyof StartDomainDomainTermMgtCreateDomainTermStartPostErrors];

export type StartDomainDomainTermMgtCreateDomainTermStartPostResponses = {
    /**
     * Successful Response
     */
    200: DomainTerm;
};

export type StartDomainDomainTermMgtCreateDomainTermStartPostResponse = StartDomainDomainTermMgtCreateDomainTermStartPostResponses[keyof StartDomainDomainTermMgtCreateDomainTermStartPostResponses];

export type StartDomainDomainTermMgtGetDomainTermsStartPostData = {
    body: BodyStartDomainDomainTermMgtGetDomainTermsStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/get_domain_terms/start';
};

export type StartDomainDomainTermMgtGetDomainTermsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtGetDomainTermsStartPostError = StartDomainDomainTermMgtGetDomainTermsStartPostErrors[keyof StartDomainDomainTermMgtGetDomainTermsStartPostErrors];

export type StartDomainDomainTermMgtGetDomainTermsStartPostResponses = {
    /**
     * Response Start Domain Domain Term Mgt Get Domain Terms Start Post
     *
     * Successful Response
     */
    200: Array<DomainTerm>;
};

export type StartDomainDomainTermMgtGetDomainTermsStartPostResponse = StartDomainDomainTermMgtGetDomainTermsStartPostResponses[keyof StartDomainDomainTermMgtGetDomainTermsStartPostResponses];

export type StartDomainDomainTermMgtGetDomainTermStartPostData = {
    body: BodyStartDomainDomainTermMgtGetDomainTermStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/get_domain_term/start';
};

export type StartDomainDomainTermMgtGetDomainTermStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtGetDomainTermStartPostError = StartDomainDomainTermMgtGetDomainTermStartPostErrors[keyof StartDomainDomainTermMgtGetDomainTermStartPostErrors];

export type StartDomainDomainTermMgtGetDomainTermStartPostResponses = {
    /**
     * Successful Response
     */
    200: DomainTerm;
};

export type StartDomainDomainTermMgtGetDomainTermStartPostResponse = StartDomainDomainTermMgtGetDomainTermStartPostResponses[keyof StartDomainDomainTermMgtGetDomainTermStartPostResponses];

export type StartDomainDomainTermMgtDeleteDomainTermStartPostData = {
    body: BodyStartDomainDomainTermMgtDeleteDomainTermStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/delete_domain_term/start';
};

export type StartDomainDomainTermMgtDeleteDomainTermStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtDeleteDomainTermStartPostError = StartDomainDomainTermMgtDeleteDomainTermStartPostErrors[keyof StartDomainDomainTermMgtDeleteDomainTermStartPostErrors];

export type StartDomainDomainTermMgtDeleteDomainTermStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainDomainTermMgtUpdateDomainTermStartPostData = {
    body: BodyStartDomainDomainTermMgtUpdateDomainTermStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/update_domain_term/start';
};

export type StartDomainDomainTermMgtUpdateDomainTermStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtUpdateDomainTermStartPostError = StartDomainDomainTermMgtUpdateDomainTermStartPostErrors[keyof StartDomainDomainTermMgtUpdateDomainTermStartPostErrors];

export type StartDomainDomainTermMgtUpdateDomainTermStartPostResponses = {
    /**
     * Successful Response
     */
    200: DomainTerm;
};

export type StartDomainDomainTermMgtUpdateDomainTermStartPostResponse = StartDomainDomainTermMgtUpdateDomainTermStartPostResponses[keyof StartDomainDomainTermMgtUpdateDomainTermStartPostResponses];

export type StartProcessLaneMgtGetLaneStartPostData = {
    body: BodyStartProcessLaneMgtGetLaneStartPost;
    path?: never;
    query?: never;
    url: '/process/lane_mgt/get_lane/start';
};

export type StartProcessLaneMgtGetLaneStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessLaneMgtGetLaneStartPostError = StartProcessLaneMgtGetLaneStartPostErrors[keyof StartProcessLaneMgtGetLaneStartPostErrors];

export type StartProcessLaneMgtGetLaneStartPostResponses = {
    /**
     * Successful Response
     */
    200: Lane;
};

export type StartProcessLaneMgtGetLaneStartPostResponse = StartProcessLaneMgtGetLaneStartPostResponses[keyof StartProcessLaneMgtGetLaneStartPostResponses];

export type StartProcessLaneMgtGetLaneByRoleIdStartPostData = {
    body: BodyStartProcessLaneMgtGetLaneByRoleIdStartPost;
    path?: never;
    query?: never;
    url: '/process/lane_mgt/get_lane_by_role_id/start';
};

export type StartProcessLaneMgtGetLaneByRoleIdStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessLaneMgtGetLaneByRoleIdStartPostError = StartProcessLaneMgtGetLaneByRoleIdStartPostErrors[keyof StartProcessLaneMgtGetLaneByRoleIdStartPostErrors];

export type StartProcessLaneMgtGetLaneByRoleIdStartPostResponses = {
    /**
     * Successful Response
     */
    200: Lane;
};

export type StartProcessLaneMgtGetLaneByRoleIdStartPostResponse = StartProcessLaneMgtGetLaneByRoleIdStartPostResponses[keyof StartProcessLaneMgtGetLaneByRoleIdStartPostResponses];

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostData = {
    body: BodyStartProcessLaneMgtGetLaneByBpmnIdStartPost;
    path?: never;
    query?: never;
    url: '/process/lane_mgt/get_lane_by_bpmn_id/start';
};

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostError = StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors[keyof StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors];

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses = {
    /**
     * Successful Response
     */
    200: Lane;
};

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostResponse = StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses[keyof StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses];

export type StartProcessLaneMgtGetLanesByProcessStartPostData = {
    body: BodyStartProcessLaneMgtGetLanesByProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/lane_mgt/get_lanes_by_process/start';
};

export type StartProcessLaneMgtGetLanesByProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessLaneMgtGetLanesByProcessStartPostError = StartProcessLaneMgtGetLanesByProcessStartPostErrors[keyof StartProcessLaneMgtGetLanesByProcessStartPostErrors];

export type StartProcessLaneMgtGetLanesByProcessStartPostResponses = {
    /**
     * Response Start Process Lane Mgt Get Lanes By Process Start Post
     *
     * Successful Response
     */
    200: Array<Lane>;
};

export type StartProcessLaneMgtGetLanesByProcessStartPostResponse = StartProcessLaneMgtGetLanesByProcessStartPostResponses[keyof StartProcessLaneMgtGetLanesByProcessStartPostResponses];

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData = {
    body: BodyStartProcessProcessElementMgtGetProcessElementByBpmnIdStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_process_element_by_bpmn_id/start';
};

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostError = StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors[keyof StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors];

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessElement;
};

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponse = StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses[keyof StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses];

export type StartProcessProcessElementMgtDeleteGatewayStartPostData = {
    body: BodyStartProcessProcessElementMgtDeleteGatewayStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/delete_gateway/start';
};

export type StartProcessProcessElementMgtDeleteGatewayStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtDeleteGatewayStartPostError = StartProcessProcessElementMgtDeleteGatewayStartPostErrors[keyof StartProcessProcessElementMgtDeleteGatewayStartPostErrors];

export type StartProcessProcessElementMgtDeleteGatewayStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtUpdateEventStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateEventStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_event/start';
};

export type StartProcessProcessElementMgtUpdateEventStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateEventStartPostError = StartProcessProcessElementMgtUpdateEventStartPostErrors[keyof StartProcessProcessElementMgtUpdateEventStartPostErrors];

export type StartProcessProcessElementMgtUpdateEventStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtUpdateTaskEvidenceStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateTaskEvidenceStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_task_evidence/start';
};

export type StartProcessProcessElementMgtUpdateTaskEvidenceStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateTaskEvidenceStartPostError = StartProcessProcessElementMgtUpdateTaskEvidenceStartPostErrors[keyof StartProcessProcessElementMgtUpdateTaskEvidenceStartPostErrors];

export type StartProcessProcessElementMgtUpdateTaskEvidenceStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData = {
    body: BodyStartProcessProcessElementMgtGetProcessElementsByProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_process_elements_by_process/start';
};

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostError = StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors[keyof StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors];

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses = {
    /**
     * Response Start Process Process Element Mgt Get Process Elements By Process Start Post
     *
     * Successful Response
     */
    200: Array<ProcessTask | ProcessGateway | ProcessEvent | ProcessFlow>;
};

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponse = StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses[keyof StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses];

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostData = {
    body: BodyStartProcessProcessElementMgtGenerateUserInterfaceStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/generate_user_interface/start';
};

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostError = StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors[keyof StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors];

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses = {
    /**
     *
     * Limited stream of SSE messages. Sends `event: open` and `event: close` when opening/closing the stream.
     * Sends a JSON object with chunks of the content.
     *
     */
    200: string;
};

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponse = StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses[keyof StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses];

export type StartProcessProcessElementMgtUpdateGatewayStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateGatewayStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_gateway/start';
};

export type StartProcessProcessElementMgtUpdateGatewayStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateGatewayStartPostError = StartProcessProcessElementMgtUpdateGatewayStartPostErrors[keyof StartProcessProcessElementMgtUpdateGatewayStartPostErrors];

export type StartProcessProcessElementMgtUpdateGatewayStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetEventStartPostData = {
    body: BodyStartProcessProcessElementMgtGetEventStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_event/start';
};

export type StartProcessProcessElementMgtGetEventStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetEventStartPostError = StartProcessProcessElementMgtGetEventStartPostErrors[keyof StartProcessProcessElementMgtGetEventStartPostErrors];

export type StartProcessProcessElementMgtGetEventStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessEvent;
};

export type StartProcessProcessElementMgtGetEventStartPostResponse = StartProcessProcessElementMgtGetEventStartPostResponses[keyof StartProcessProcessElementMgtGetEventStartPostResponses];

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostData = {
    body: BodyStartProcessProcessElementMgtUnarchiveProcessElementStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/unarchive_process_element/start';
};

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostError = StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors[keyof StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors];

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtDeleteEventStartPostData = {
    body: BodyStartProcessProcessElementMgtDeleteEventStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/delete_event/start';
};

export type StartProcessProcessElementMgtDeleteEventStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtDeleteEventStartPostError = StartProcessProcessElementMgtDeleteEventStartPostErrors[keyof StartProcessProcessElementMgtDeleteEventStartPostErrors];

export type StartProcessProcessElementMgtDeleteEventStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtArchiveProcessElementStartPostData = {
    body: BodyStartProcessProcessElementMgtArchiveProcessElementStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/archive_process_element/start';
};

export type StartProcessProcessElementMgtArchiveProcessElementStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtArchiveProcessElementStartPostError = StartProcessProcessElementMgtArchiveProcessElementStartPostErrors[keyof StartProcessProcessElementMgtArchiveProcessElementStartPostErrors];

export type StartProcessProcessElementMgtArchiveProcessElementStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_process_element_entity_refs/start';
};

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostError = StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostErrors[keyof StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostErrors];

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessElement;
};

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponse = StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponses[keyof StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponses];

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostData = {
    body: BodyStartProcessProcessElementMgtGetProcessElementsByEntityStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_process_elements_by_entity/start';
};

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostError = StartProcessProcessElementMgtGetProcessElementsByEntityStartPostErrors[keyof StartProcessProcessElementMgtGetProcessElementsByEntityStartPostErrors];

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponses = {
    /**
     * Response Start Process Process Element Mgt Get Process Elements By Entity Start Post
     *
     * Successful Response
     */
    200: Array<EntityTaskRef>;
};

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponse = StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponses[keyof StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponses];

export type StartProcessProcessElementMgtDeleteTaskStartPostData = {
    body: BodyStartProcessProcessElementMgtDeleteTaskStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/delete_task/start';
};

export type StartProcessProcessElementMgtDeleteTaskStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtDeleteTaskStartPostError = StartProcessProcessElementMgtDeleteTaskStartPostErrors[keyof StartProcessProcessElementMgtDeleteTaskStartPostErrors];

export type StartProcessProcessElementMgtDeleteTaskStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetTaskStartPostData = {
    body: BodyStartProcessProcessElementMgtGetTaskStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_task/start';
};

export type StartProcessProcessElementMgtGetTaskStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetTaskStartPostError = StartProcessProcessElementMgtGetTaskStartPostErrors[keyof StartProcessProcessElementMgtGetTaskStartPostErrors];

export type StartProcessProcessElementMgtGetTaskStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessTask;
};

export type StartProcessProcessElementMgtGetTaskStartPostResponse = StartProcessProcessElementMgtGetTaskStartPostResponses[keyof StartProcessProcessElementMgtGetTaskStartPostResponses];

export type StartProcessProcessElementMgtUpdateFlowStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateFlowStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_flow/start';
};

export type StartProcessProcessElementMgtUpdateFlowStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateFlowStartPostError = StartProcessProcessElementMgtUpdateFlowStartPostErrors[keyof StartProcessProcessElementMgtUpdateFlowStartPostErrors];

export type StartProcessProcessElementMgtUpdateFlowStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetGatewayStartPostData = {
    body: BodyStartProcessProcessElementMgtGetGatewayStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_gateway/start';
};

export type StartProcessProcessElementMgtGetGatewayStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetGatewayStartPostError = StartProcessProcessElementMgtGetGatewayStartPostErrors[keyof StartProcessProcessElementMgtGetGatewayStartPostErrors];

export type StartProcessProcessElementMgtGetGatewayStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessGateway;
};

export type StartProcessProcessElementMgtGetGatewayStartPostResponse = StartProcessProcessElementMgtGetGatewayStartPostResponses[keyof StartProcessProcessElementMgtGetGatewayStartPostResponses];

export type StartProcessProcessElementMgtUpdateTaskStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateTaskStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_task/start';
};

export type StartProcessProcessElementMgtUpdateTaskStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateTaskStartPostError = StartProcessProcessElementMgtUpdateTaskStartPostErrors[keyof StartProcessProcessElementMgtUpdateTaskStartPostErrors];

export type StartProcessProcessElementMgtUpdateTaskStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetFlowStartPostData = {
    body: BodyStartProcessProcessElementMgtGetFlowStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_flow/start';
};

export type StartProcessProcessElementMgtGetFlowStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetFlowStartPostError = StartProcessProcessElementMgtGetFlowStartPostErrors[keyof StartProcessProcessElementMgtGetFlowStartPostErrors];

export type StartProcessProcessElementMgtGetFlowStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessFlow;
};

export type StartProcessProcessElementMgtGetFlowStartPostResponse = StartProcessProcessElementMgtGetFlowStartPostResponses[keyof StartProcessProcessElementMgtGetFlowStartPostResponses];

export type StartProcessProcessElementMgtDeleteFlowStartPostData = {
    body: BodyStartProcessProcessElementMgtDeleteFlowStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/delete_flow/start';
};

export type StartProcessProcessElementMgtDeleteFlowStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtDeleteFlowStartPostError = StartProcessProcessElementMgtDeleteFlowStartPostErrors[keyof StartProcessProcessElementMgtDeleteFlowStartPostErrors];

export type StartProcessProcessElementMgtDeleteFlowStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtUpdateProcessOrdersStartPostData = {
    body: BodyStartProcessProcessMgtUpdateProcessOrdersStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/update_process_orders/start';
};

export type StartProcessProcessMgtUpdateProcessOrdersStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtUpdateProcessOrdersStartPostError = StartProcessProcessMgtUpdateProcessOrdersStartPostErrors[keyof StartProcessProcessMgtUpdateProcessOrdersStartPostErrors];

export type StartProcessProcessMgtUpdateProcessOrdersStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtGetProcessStartPostData = {
    body: BodyStartProcessProcessMgtGetProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/get_process/start';
};

export type StartProcessProcessMgtGetProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtGetProcessStartPostError = StartProcessProcessMgtGetProcessStartPostErrors[keyof StartProcessProcessMgtGetProcessStartPostErrors];

export type StartProcessProcessMgtGetProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: Process;
};

export type StartProcessProcessMgtGetProcessStartPostResponse = StartProcessProcessMgtGetProcessStartPostResponses[keyof StartProcessProcessMgtGetProcessStartPostResponses];

export type StartProcessProcessMgtMoveProcessStartPostData = {
    body: BodyStartProcessProcessMgtMoveProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/move_process/start';
};

export type StartProcessProcessMgtMoveProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtMoveProcessStartPostError = StartProcessProcessMgtMoveProcessStartPostErrors[keyof StartProcessProcessMgtMoveProcessStartPostErrors];

export type StartProcessProcessMgtMoveProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtDeployProcessStartPostData = {
    body: BodyStartProcessProcessMgtDeployProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/deploy_process/start';
};

export type StartProcessProcessMgtDeployProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtDeployProcessStartPostError = StartProcessProcessMgtDeployProcessStartPostErrors[keyof StartProcessProcessMgtDeployProcessStartPostErrors];

export type StartProcessProcessMgtDeployProcessStartPostResponses = {
    /**
     * Response Start Process Process Mgt Deploy Process Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: unknown;
    };
};

export type StartProcessProcessMgtDeployProcessStartPostResponse = StartProcessProcessMgtDeployProcessStartPostResponses[keyof StartProcessProcessMgtDeployProcessStartPostResponses];

export type StartProcessProcessMgtUpdateProcessStartPostData = {
    body: BodyStartProcessProcessMgtUpdateProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/update_process/start';
};

export type StartProcessProcessMgtUpdateProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtUpdateProcessStartPostError = StartProcessProcessMgtUpdateProcessStartPostErrors[keyof StartProcessProcessMgtUpdateProcessStartPostErrors];

export type StartProcessProcessMgtUpdateProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtDeleteProcessStartPostData = {
    body: BodyStartProcessProcessMgtDeleteProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/delete_process/start';
};

export type StartProcessProcessMgtDeleteProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtDeleteProcessStartPostError = StartProcessProcessMgtDeleteProcessStartPostErrors[keyof StartProcessProcessMgtDeleteProcessStartPostErrors];

export type StartProcessProcessMgtDeleteProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtCreateProcessStartPostData = {
    body: BodyStartProcessProcessMgtCreateProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/create_process/start';
};

export type StartProcessProcessMgtCreateProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtCreateProcessStartPostError = StartProcessProcessMgtCreateProcessStartPostErrors[keyof StartProcessProcessMgtCreateProcessStartPostErrors];

export type StartProcessProcessMgtCreateProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: Process;
};

export type StartProcessProcessMgtCreateProcessStartPostResponse = StartProcessProcessMgtCreateProcessStartPostResponses[keyof StartProcessProcessMgtCreateProcessStartPostResponses];

export type StartProcessProcessMgtGetProcessesByProductStartPostData = {
    body: BodyStartProcessProcessMgtGetProcessesByProductStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/get_processes_by_product/start';
};

export type StartProcessProcessMgtGetProcessesByProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtGetProcessesByProductStartPostError = StartProcessProcessMgtGetProcessesByProductStartPostErrors[keyof StartProcessProcessMgtGetProcessesByProductStartPostErrors];

export type StartProcessProcessMgtGetProcessesByProductStartPostResponses = {
    /**
     * Response Start Process Process Mgt Get Processes By Product Start Post
     *
     * Successful Response
     */
    200: Array<Process>;
};

export type StartProcessProcessMgtGetProcessesByProductStartPostResponse = StartProcessProcessMgtGetProcessesByProductStartPostResponses[keyof StartProcessProcessMgtGetProcessesByProductStartPostResponses];

export type StartProcessProcessMgtGenerateDefinitionXmlStartPostData = {
    body: BodyStartProcessProcessMgtGenerateDefinitionXmlStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/generate_definition_xml/start';
};

export type StartProcessProcessMgtGenerateDefinitionXmlStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtGenerateDefinitionXmlStartPostError = StartProcessProcessMgtGenerateDefinitionXmlStartPostErrors[keyof StartProcessProcessMgtGenerateDefinitionXmlStartPostErrors];

export type StartProcessProcessMgtGenerateDefinitionXmlStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetUsersUserGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/';
};

export type GetUsersUserGetResponses = {
    /**
     * Response Get Users User  Get
     *
     * Successful Response
     */
    200: Array<OrganizationUser>;
};

export type GetUsersUserGetResponse = GetUsersUserGetResponses[keyof GetUsersUserGetResponses];

export type CreateUserUserPostData = {
    body: CreateUser;
    path?: never;
    query?: never;
    url: '/user/';
};

export type CreateUserUserPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateUserUserPostError = CreateUserUserPostErrors[keyof CreateUserUserPostErrors];

export type CreateUserUserPostResponses = {
    /**
     * Successful Response
     */
    200: OrganizationUser;
};

export type CreateUserUserPostResponse = CreateUserUserPostResponses[keyof CreateUserUserPostResponses];

export type SignupUserSignupPostData = {
    body: CreateUser;
    path?: never;
    query?: never;
    url: '/user/signup';
};

export type SignupUserSignupPostErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type SignupUserSignupPostError = SignupUserSignupPostErrors[keyof SignupUserSignupPostErrors];

export type SignupUserSignupPostResponses = {
    /**
     * Successful Response
     */
    200: MeUser;
};

export type SignupUserSignupPostResponse = SignupUserSignupPostResponses[keyof SignupUserSignupPostResponses];

export type ValidateInvitationUserInvitationValidatePostData = {
    body: ValidateInvitationRequest;
    path?: never;
    query?: never;
    url: '/user/invitation/validate';
};

export type ValidateInvitationUserInvitationValidatePostErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type ValidateInvitationUserInvitationValidatePostError = ValidateInvitationUserInvitationValidatePostErrors[keyof ValidateInvitationUserInvitationValidatePostErrors];

export type ValidateInvitationUserInvitationValidatePostResponses = {
    /**
     * Successful Response
     */
    200: InvitationValidation;
};

export type ValidateInvitationUserInvitationValidatePostResponse = ValidateInvitationUserInvitationValidatePostResponses[keyof ValidateInvitationUserInvitationValidatePostResponses];

export type SignupWithInvitationUserSignupWithInvitationPostData = {
    body: CreateUserWithInvitation;
    path?: never;
    query?: never;
    url: '/user/signup-with-invitation';
};

export type SignupWithInvitationUserSignupWithInvitationPostErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type SignupWithInvitationUserSignupWithInvitationPostError = SignupWithInvitationUserSignupWithInvitationPostErrors[keyof SignupWithInvitationUserSignupWithInvitationPostErrors];

export type SignupWithInvitationUserSignupWithInvitationPostResponses = {
    /**
     * Successful Response
     */
    200: MeUser;
};

export type SignupWithInvitationUserSignupWithInvitationPostResponse = SignupWithInvitationUserSignupWithInvitationPostResponses[keyof SignupWithInvitationUserSignupWithInvitationPostResponses];

export type ResendInvitationEndpointUserUserIdResendInvitationPostData = {
    body?: never;
    path: {
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/user/{user_id}/resend-invitation';
};

export type ResendInvitationEndpointUserUserIdResendInvitationPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ResendInvitationEndpointUserUserIdResendInvitationPostError = ResendInvitationEndpointUserUserIdResendInvitationPostErrors[keyof ResendInvitationEndpointUserUserIdResendInvitationPostErrors];

export type ResendInvitationEndpointUserUserIdResendInvitationPostResponses = {
    /**
     * Successful Response
     */
    200: OrganizationUser;
};

export type ResendInvitationEndpointUserUserIdResendInvitationPostResponse = ResendInvitationEndpointUserUserIdResendInvitationPostResponses[keyof ResendInvitationEndpointUserUserIdResendInvitationPostResponses];

export type DeleteUserUserUserIdDeleteData = {
    body?: never;
    path: {
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/user/{user_id}';
};

export type DeleteUserUserUserIdDeleteErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteUserUserUserIdDeleteError = DeleteUserUserUserIdDeleteErrors[keyof DeleteUserUserUserIdDeleteErrors];

export type DeleteUserUserUserIdDeleteResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetSelfUserMeGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/me';
};

export type GetSelfUserMeGetResponses = {
    /**
     * Successful Response
     */
    200: MeUser;
};

export type GetSelfUserMeGetResponse = GetSelfUserMeGetResponses[keyof GetSelfUserMeGetResponses];

export type UpdateSelfUserMePutData = {
    body: UpdateUser;
    path?: never;
    query?: never;
    url: '/user/me';
};

export type UpdateSelfUserMePutErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateSelfUserMePutError = UpdateSelfUserMePutErrors[keyof UpdateSelfUserMePutErrors];

export type UpdateSelfUserMePutResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UpdateSelfPreferencesUserMePreferencesPatchData = {
    body: UpdatePreferences;
    path?: never;
    query?: never;
    url: '/user/me/preferences';
};

export type UpdateSelfPreferencesUserMePreferencesPatchErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateSelfPreferencesUserMePreferencesPatchError = UpdateSelfPreferencesUserMePreferencesPatchErrors[keyof UpdateSelfPreferencesUserMePreferencesPatchErrors];

export type UpdateSelfPreferencesUserMePreferencesPatchResponses = {
    /**
     * Successful Response
     */
    200: MeUser;
};

export type UpdateSelfPreferencesUserMePreferencesPatchResponse = UpdateSelfPreferencesUserMePreferencesPatchResponses[keyof UpdateSelfPreferencesUserMePreferencesPatchResponses];

export type GetDomainRolesUserUserIdDomainRolesGetData = {
    body?: never;
    path: {
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/user/{user_id}/domain-roles';
};

export type GetDomainRolesUserUserIdDomainRolesGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDomainRolesUserUserIdDomainRolesGetError = GetDomainRolesUserUserIdDomainRolesGetErrors[keyof GetDomainRolesUserUserIdDomainRolesGetErrors];

export type GetDomainRolesUserUserIdDomainRolesGetResponses = {
    /**
     * Response Get Domain Roles User  User Id  Domain Roles Get
     *
     * Successful Response
     */
    200: Array<DomainRole>;
};

export type GetDomainRolesUserUserIdDomainRolesGetResponse = GetDomainRolesUserUserIdDomainRolesGetResponses[keyof GetDomainRolesUserUserIdDomainRolesGetResponses];

export type UpdateAuthorizationUserUserIdAuthorizationPutData = {
    body: UpdateUserAuthorization;
    path: {
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/user/{user_id}/authorization';
};

export type UpdateAuthorizationUserUserIdAuthorizationPutErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateAuthorizationUserUserIdAuthorizationPutError = UpdateAuthorizationUserUserIdAuthorizationPutErrors[keyof UpdateAuthorizationUserUserIdAuthorizationPutErrors];

export type UpdateAuthorizationUserUserIdAuthorizationPutResponses = {
    /**
     * Successful Response
     */
    200: OrganizationUser;
};

export type UpdateAuthorizationUserUserIdAuthorizationPutResponse = UpdateAuthorizationUserUserIdAuthorizationPutResponses[keyof UpdateAuthorizationUserUserIdAuthorizationPutResponses];

export type ListApiKeysUserApiKeysGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/api-keys';
};

export type ListApiKeysUserApiKeysGetResponses = {
    /**
     * Successful Response
     */
    200: ApiKeysList;
};

export type ListApiKeysUserApiKeysGetResponse = ListApiKeysUserApiKeysGetResponses[keyof ListApiKeysUserApiKeysGetResponses];

export type CreateApiKeyUserApiKeyPostData = {
    body: BodyCreateApiKeyUserApiKeyPost;
    path?: never;
    query?: never;
    url: '/user/api-key';
};

export type CreateApiKeyUserApiKeyPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateApiKeyUserApiKeyPostError = CreateApiKeyUserApiKeyPostErrors[keyof CreateApiKeyUserApiKeyPostErrors];

export type CreateApiKeyUserApiKeyPostResponses = {
    /**
     * Successful Response
     */
    201: ApiKeyCreated;
};

export type CreateApiKeyUserApiKeyPostResponse = CreateApiKeyUserApiKeyPostResponses[keyof CreateApiKeyUserApiKeyPostResponses];

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteData = {
    body?: never;
    path: {
        /**
         * Api Key Id
         */
        api_key_id: string;
    };
    query?: never;
    url: '/user/api-key/{api_key_id}';
};

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteError = RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors[keyof RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors];

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteResponse = RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses[keyof RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses];

export type RecordPolicyAcceptanceUserPolicyAcceptancePostData = {
    body: PolicyAcceptanceRequest;
    path?: never;
    query?: never;
    url: '/user/policy-acceptance';
};

export type RecordPolicyAcceptanceUserPolicyAcceptancePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RecordPolicyAcceptanceUserPolicyAcceptancePostError = RecordPolicyAcceptanceUserPolicyAcceptancePostErrors[keyof RecordPolicyAcceptanceUserPolicyAcceptancePostErrors];

export type RecordPolicyAcceptanceUserPolicyAcceptancePostResponses = {
    /**
     * Successful Response
     */
    200: PolicyAcceptance;
};

export type RecordPolicyAcceptanceUserPolicyAcceptancePostResponse = RecordPolicyAcceptanceUserPolicyAcceptancePostResponses[keyof RecordPolicyAcceptanceUserPolicyAcceptancePostResponses];

export type GetPolicyAcceptancesUserPolicyAcceptancesGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Policy Type
         */
        policy_type?: string | null;
    };
    url: '/user/policy-acceptances';
};

export type GetPolicyAcceptancesUserPolicyAcceptancesGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPolicyAcceptancesUserPolicyAcceptancesGetError = GetPolicyAcceptancesUserPolicyAcceptancesGetErrors[keyof GetPolicyAcceptancesUserPolicyAcceptancesGetErrors];

export type GetPolicyAcceptancesUserPolicyAcceptancesGetResponses = {
    /**
     * Response Get Policy Acceptances  User Policy Acceptances Get
     *
     * Successful Response
     */
    200: Array<PolicyAcceptance>;
};

export type GetPolicyAcceptancesUserPolicyAcceptancesGetResponse = GetPolicyAcceptancesUserPolicyAcceptancesGetResponses[keyof GetPolicyAcceptancesUserPolicyAcceptancesGetResponses];

export type GetPolicyStatusUserPolicyStatusGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/policy-status';
};

export type GetPolicyStatusUserPolicyStatusGetResponses = {
    /**
     * Successful Response
     */
    200: PolicyAcceptanceStatus;
};

export type GetPolicyStatusUserPolicyStatusGetResponse = GetPolicyStatusUserPolicyStatusGetResponses[keyof GetPolicyStatusUserPolicyStatusGetResponses];

export type GetAllPlatformUsersUserAllGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/all/';
};

export type GetAllPlatformUsersUserAllGetErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type GetAllPlatformUsersUserAllGetError = GetAllPlatformUsersUserAllGetErrors[keyof GetAllPlatformUsersUserAllGetErrors];

export type GetAllPlatformUsersUserAllGetResponses = {
    /**
     * Response Get All Platform Users User All  Get
     *
     * Successful Response
     */
    200: Array<MeUser>;
};

export type GetAllPlatformUsersUserAllGetResponse = GetAllPlatformUsersUserAllGetResponses[keyof GetAllPlatformUsersUserAllGetResponses];

export type GetFirebaseUserByEmailUserFirebaseEmailGetData = {
    body?: never;
    path: {
        /**
         * Email
         */
        email: string;
    };
    query?: never;
    url: '/user/firebase/{email}';
};

export type GetFirebaseUserByEmailUserFirebaseEmailGetErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type GetFirebaseUserByEmailUserFirebaseEmailGetError = GetFirebaseUserByEmailUserFirebaseEmailGetErrors[keyof GetFirebaseUserByEmailUserFirebaseEmailGetErrors];

export type GetFirebaseUserByEmailUserFirebaseEmailGetResponses = {
    /**
     * Successful Response
     */
    200: FirebaseUser;
};

export type GetFirebaseUserByEmailUserFirebaseEmailGetResponse = GetFirebaseUserByEmailUserFirebaseEmailGetResponses[keyof GetFirebaseUserByEmailUserFirebaseEmailGetResponses];

export type StartAiTaskMgtGetTaskProvidersStartPostData = {
    body: GetTaskProvidersRequest;
    path?: never;
    query?: never;
    url: '/ai/task_mgt/get_task_providers/start';
};

export type StartAiTaskMgtGetTaskProvidersStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartAiTaskMgtGetTaskProvidersStartPostError = StartAiTaskMgtGetTaskProvidersStartPostErrors[keyof StartAiTaskMgtGetTaskProvidersStartPostErrors];

export type StartAiTaskMgtGetTaskProvidersStartPostResponses = {
    /**
     * Successful Response
     */
    200: SupportedProvidersResponse;
};

export type StartAiTaskMgtGetTaskProvidersStartPostResponse = StartAiTaskMgtGetTaskProvidersStartPostResponses[keyof StartAiTaskMgtGetTaskProvidersStartPostResponses];

export type StartAiEvaluationGetTaskEvaluationsStartPostData = {
    body: GetTaskEvaluationsRequest;
    path?: never;
    query?: never;
    url: '/ai/evaluation/get_task_evaluations/start';
};

export type StartAiEvaluationGetTaskEvaluationsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartAiEvaluationGetTaskEvaluationsStartPostError = StartAiEvaluationGetTaskEvaluationsStartPostErrors[keyof StartAiEvaluationGetTaskEvaluationsStartPostErrors];

export type StartAiEvaluationGetTaskEvaluationsStartPostResponses = {
    /**
     * Successful Response
     */
    200: TaskEvaluationListResponse;
};

export type StartAiEvaluationGetTaskEvaluationsStartPostResponse = StartAiEvaluationGetTaskEvaluationsStartPostResponses[keyof StartAiEvaluationGetTaskEvaluationsStartPostResponses];

export type StartAiTaskMgtRunTaskStartPostData = {
    body: TaskEvaluationRequest;
    path?: never;
    query?: never;
    url: '/ai/task_mgt/run_task/start';
};

export type StartAiTaskMgtRunTaskStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartAiTaskMgtRunTaskStartPostError = StartAiTaskMgtRunTaskStartPostErrors[keyof StartAiTaskMgtRunTaskStartPostErrors];

export type StartAiTaskMgtRunTaskStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type SearchSearchGetData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Q
         */
        q: string;
    };
    url: '/search/';
};

export type SearchSearchGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SearchSearchGetError = SearchSearchGetErrors[keyof SearchSearchGetErrors];

export type SearchSearchGetResponses = {
    /**
     * Successful Response
     */
    200: SearchResponse;
};

export type SearchSearchGetResponse = SearchSearchGetResponses[keyof SearchSearchGetResponses];

export type PreviewLinkProxyPreviewLinkGetData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Url
         */
        url: string;
    };
    url: '/proxy/preview-link';
};

export type PreviewLinkProxyPreviewLinkGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PreviewLinkProxyPreviewLinkGetError = PreviewLinkProxyPreviewLinkGetErrors[keyof PreviewLinkProxyPreviewLinkGetErrors];

export type PreviewLinkProxyPreviewLinkGetResponses = {
    /**
     * Successful Response
     */
    200: LinkPreview;
};

export type PreviewLinkProxyPreviewLinkGetResponse = PreviewLinkProxyPreviewLinkGetResponses[keyof PreviewLinkProxyPreviewLinkGetResponses];

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetData = {
    body?: never;
    path: {
        integration_type: IntegrationType;
    };
    query: {
        /**
         * Redirect Uri
         */
        redirect_uri: string;
    };
    url: '/integrations/oauth2/client/prepare/{integration_type}';
};

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetError = PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors[keyof PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors];

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses = {
    /**
     * Successful Response
     */
    200: PrepareResponse;
};

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponse = PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses[keyof PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses];

export type ExchangeTokenIntegrationsOauth2ClientTokenPostData = {
    body: TokenRequest;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/client/token';
};

export type ExchangeTokenIntegrationsOauth2ClientTokenPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExchangeTokenIntegrationsOauth2ClientTokenPostError = ExchangeTokenIntegrationsOauth2ClientTokenPostErrors[keyof ExchangeTokenIntegrationsOauth2ClientTokenPostErrors];

export type ExchangeTokenIntegrationsOauth2ClientTokenPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Client Id
         */
        client_id?: string | null;
        /**
         * Response Type
         */
        response_type?: string | null;
        /**
         * Redirect Uri
         */
        redirect_uri?: string | null;
        /**
         * Scope
         */
        scope?: string | null;
        /**
         * State
         */
        state?: string | null;
        /**
         * Code Challenge
         */
        code_challenge?: string | null;
        /**
         * Code Challenge Method
         */
        code_challenge_method?: string;
    };
    url: '/integrations/oauth2/server/authorize';
};

export type AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetError = AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors[keyof AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors];

export type AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostData = {
    body: BodyGenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePost;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/server/authorize';
};

export type GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostError = GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors[keyof GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors];

export type GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type TokenEndpointIntegrationsOauth2ServerTokenPostData = {
    body: BodyTokenEndpointIntegrationsOauth2ServerTokenPost;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/server/token';
};

export type TokenEndpointIntegrationsOauth2ServerTokenPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type TokenEndpointIntegrationsOauth2ServerTokenPostError = TokenEndpointIntegrationsOauth2ServerTokenPostErrors[keyof TokenEndpointIntegrationsOauth2ServerTokenPostErrors];

export type TokenEndpointIntegrationsOauth2ServerTokenPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type RegisterClientIntegrationsOauth2ServerRegisterPostData = {
    body: ClientRegistrationRequest;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/server/register';
};

export type RegisterClientIntegrationsOauth2ServerRegisterPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RegisterClientIntegrationsOauth2ServerRegisterPostError = RegisterClientIntegrationsOauth2ServerRegisterPostErrors[keyof RegisterClientIntegrationsOauth2ServerRegisterPostErrors];

export type RegisterClientIntegrationsOauth2ServerRegisterPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type RevokeTokenIntegrationsOauth2ServerRevokePostData = {
    body: RevocationRequest;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/server/revoke';
};

export type RevokeTokenIntegrationsOauth2ServerRevokePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RevokeTokenIntegrationsOauth2ServerRevokePostError = RevokeTokenIntegrationsOauth2ServerRevokePostErrors[keyof RevokeTokenIntegrationsOauth2ServerRevokePostErrors];

export type RevokeTokenIntegrationsOauth2ServerRevokePostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type McpStreamableHttpHandlerIntegrationsMcpGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/integrations/mcp';
};

export type McpStreamableHttpHandlerIntegrationsMcpGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type McpStreamableHttpHandlerIntegrationsMcpGet2Data = {
    body?: never;
    path?: never;
    query?: never;
    url: '/integrations/mcp';
};

export type McpStreamableHttpHandlerIntegrationsMcpGet2Responses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type McpStreamableHttpHandlerIntegrationsMcpGet3Data = {
    body?: never;
    path?: never;
    query?: never;
    url: '/integrations/mcp';
};

export type McpStreamableHttpHandlerIntegrationsMcpGet3Responses = {
    /**
     * Successful Response
     */
    200: unknown;
};
